import FindIcon from '~/util/findProductsIcon.js';
import descriptionMarket from '../description/descriptionDefault';
import descriptionAltMarket from '../description/descriptionAltDefault';
import descriptionFoodMarket from '../description/descriptionFoodDefault';
import descriptionFoodAltMarket from '../description/descriptionFoodAltDefault';
export default {
    subcategory : [


        {   
            food : false,
            description : descriptionMarket.srPath('kukuruza'),
            alt: descriptionAltMarket('kukuruza'),
            id: 1,
            description_page:`<p>Cena kukuruza na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje kukuruza na svetskoj berzi, da li je osušen, da li je odmah skidan i ubran sa njive u zrnu, da li je u klipu, da li je u džaku.</br></br></p>
            <p>Cena varira od pijace do pijace, kraja u Srbiji (cena kukuruza u Vojvodini se razlikuje od cene kukuruza u istočnoj ili zapadnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>

            <p>U Srbiji se kukuruz gaji i obrađuje skoro na milion hektara zemlje. Upotrebljava se isključivo za ishranu domaćih životinja, prerađivačku industriju, ali i za ljudsku ishranu, kao i za seme za sledeću godinu.</br></br></p>
            `,
            description_meta : `Cena kukuruza na pijaci, cena kukuruza u zrnu, klipu i džaku, ponude i potražnje kukuruza na
            svetskoj berzi, trenutna cena kukuruza u Srbiji.`,
            description_path : descriptionMarket.srPath('kukuruza'),
            title_path : descriptionMarket.srPath('zitarica'),
            title_search : 'kukuruza',
            title_search_re : 'kukuruza',
            value: "kukuruz",
            value_path: "kukuruz",
            catgeory_path: "zitarice",
            text_other: 'Ako želite da pogledate cene u gazdinstvima, silosu i maloprodaji kliknite na cene po nedeljama',
            img : FindIcon.find('Kukuruz').img2,
            color : FindIcon.find('Kukuruz').color,
            stips_category : 4,
            ads_category: 'Žitarice',
            stips_source : 8,
            catgeory: 'žitarice',

        },
        // {
            
        //     food : false,
        //     alt: descriptionAltMarket('suncokret (zrno)'),
        //     id: 2,
        //     description_page: ` 

        //     <p>Cena suncokreta varira od pijace do pijace, kraja u Srbiji (cena suncokret (zrno) u Vojvodini se razlikuje od cene suncokret u istočnoj ili zapadnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
            
        //     <p>U Srbiji se suncokret gaji i obrađuje kao jedna od glavnih sastojaka za ishranu stoke.</br></br> </p>
        //     `,
        //     description_meta : `Cena suncokreta  na pijaci,  prodaja suncokreta  na veliko, ponuda i potražnja suncokreta na tržištu, trenutna cena suncokreta  po gradovima i krajevima u Srbiji.`,
        //     description : descriptionMarket.srPath('suncokreta (zrno)'),
        //     description_path : descriptionMarket.srPath('suncokreta'),
        //     title_path : descriptionMarket.srPath('zitarica'),
        //     value: "suncokret",
        //     title_search : 'suncokret',
        //     title_search_re : 'suncokret',
        //     value_path: "suncokret",
        //     catgeory_path: "zitarice",
        //     text_other: 'Ako želite da pogledate cene u gazdinstvima, silosu i maloprodaji kliknite na cene po nedeljama',
        //     img : FindIcon.find('Suncokret').img2,
        //     color : FindIcon.find('Suncokret').color,
        //     stips_category : 4,
        //     ads_category: 'Žitarice',
        //     stips_source : 8,
        //     catgeory: 'žitarice',

        // },
        {
            
            food : false,
            alt: descriptionAltMarket('lucerke (seno u balama)'),
            id: 2,
            description_page: `<p>Cena lucerke, dateline, sena u balama na pijaci zavisi od kvaliteta košnja, broj letnjih košenja deteline i sena, rodne godine, ponude i potražnje lucerke na tržištu, deteline, bala sena. Prodaja deteline je na veliko isključivo po balama, prodaja na malo je po bali sena.</br></br></p>

            <p>Cena deteline varira od pijace do pijace, kraja u Srbiji (cena deteline u Vojvodini se razlikuje od cene deteline u istočnoj ili zapadnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
            
            <p>U Srbiji se lucerka, detelina, seno gaji i obrađuje kao jedna od glavnih sastojaka za ishranu stoke.</br></br> </p>
            `,
            description_meta : `Cena lucerke, dateline, sena u balama na pijaci, cena deteline po bali, prodaja deteline i sena na veliko, ponuda i potražnja deteline na tržištu, trenutna cena deteline i bala sena po gradovima i krajevima u Srbiji.`,
            description : descriptionMarket.srPath('lucerke (seno u balama)'),
            description_path : descriptionMarket.srPath('lucerke'),
            title_path : descriptionMarket.srPath('zitarica'),
            value: "lucerka",
            title_search : 'lucerke',
            title_search_re : 'lucerke',
            value_path: "lucerka",
            catgeory_path: "zitarice",
            text_other: 'Ako želite da pogledate cene u gazdinstvima, silosu i maloprodaji kliknite na cene po nedeljama',
            img : FindIcon.find('Lucerka').img2,
            color : FindIcon.find('Lucerka').color,
            stips_category : 4,
            ads_category: 'Žitarice',
            stips_source : 8,
            catgeory: 'žitarice',

        },
        {
            food : false,
            alt: descriptionAltMarket('pšenice'),  
            id: 3,
            description_page: `<p>Cena pšenice na pijaci u Srbiji zavisi od kvaliteta vršidbe, rodne godine, ponude i potražnje pšenice na svetskoj berzi. Prodaja pšenice je po tonama na veliko ili po džakovima na malo.</br></br></p>

            <p>Cena pšenice varira od pijace do pijace, kraja u Srbiji (cena pšenice u Vojvodini se razlikuje od cene pšenice u istočnoj ili zapadnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
            
            <p>U Srbiji se pšenica gaji i obrađuje kao jedna od glavnih žitarica, ako ne i prva na toj listi. Upotreba pšenice je velika u ishrani domaćinstava oko 70% (hleb, peciva, razna testa, testenina, kolači, keksi), ostala upotreba je u industrijskoj proizvodnji i hrani za stoku. </br></br></p>
            `,
            description_meta : `Cena pšenice na pijaci, cena pšenice po toni i džaku, prodaja pšenice na veliko, ponuda i potražnja pšenice na svetskoj berzi, trenutna cena pšenice u Srbiji.`,
            description :descriptionMarket.srPath('pšenice'),
            description_path :descriptionMarket.srPath('psenice'),
            title_path : descriptionMarket.srPath('zitarica'),
            value: "pšenica",
            value_path: "psenica",
            title_search : 'psenice',
            title_search_re : 'pšenice',
            catgeory_path: "zitarice",
            text_other: 'Ako želite da pogledate cene u gazdinstvima, silosu i maloprodaji kliknite na cene po nedeljama',
            img : FindIcon.find('Pšenica').img2,
            color : FindIcon.find('Pšenica').color,
            stips_category : 4,
            ads_category: 'Žitarice',
            stips_source : 8,
            catgeory: 'žitarice',

        },
        {
            food : false,
            id: 4,
            description_page: `<p>Cena soje i sojinog zrna na pijaci u Srbiji zavisi od kvaliteta vršidbe soje, rodne godine, ponude i potražnje soje na svetskoj berzi. Prodaja soje i sojinog zrna je po tonama na veliko ili po džakovima na malo (džak od 10, 20 ili 50 kg).</br></br></p>

            <p>Cena soje varira od pijace do pijace, kraja u Srbiji (cena soje u Vojvodini se razlikuje od cene soje u istočnoj ili zapadnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
            
            <p>U Srbiji se soja gaji i obrađuje kao jedna od sekundarnih žitarica. Upotreba soje je u industrijskoj proizvodnji, ishrani stoke, ali i za ishranu u domaćinstvima.</br></br></p>
            `,
            description_meta : `Cena soje i sojinog zrna na pijaci, cena soje po toni i džaku, prodaja soje na veliko, ponuda i potražnja soje na svetskoj berzi, trenutna cena soje po gradovima i krajevima u Srbiji.`,
            alt: descriptionAltMarket('soje'),
            description : descriptionMarket.srPath('soje'),
            description_path : descriptionMarket.srPath('soje'),
            title_path : descriptionMarket.srPath('zitarica'),
            value: "sojino zrno",
            value_path: "sojino",
            catgeory_path: "zitarice",
            text_other: 'Ako želite da pogledate cene u gazdinstvima, silosu i maloprodaji kliknite na cene po nedeljama',
            title_search : 'soje',
            title_search_re : 'soje',
            avatar: 'pš',
            img : FindIcon.find('Sojino zrno').img2,
            color : FindIcon.find('Sojino zrno').color,           
            stips_category : 4,
            ads_category: 'Žitarice',
            stips_source : 8,
            catgeory: 'žitarice',

        },
        {
            food : false,

            id: 5,
            description_page: `<p>Cena ječma na pijaci u Srbiji zavisi od kvaliteta vršidbe ječma, rodne godine, ponude i potražnje ječma na svetskoj berzi i tržištu. Prodaja ječma je po tonama na veliko ili po džakovima na malo (džak od 50 kg).</br></br></p>

            <p>Cena ječma varira od pijace do pijace, kraja u Srbiji (cena ječma u Vojvodini se razlikuje od cene ječma u istočnoj ili zapadnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
            
            <p>U Srbiji se ječam gaji i obrađuje kao jedna od sekundarnih žitarica, po nekoj statistici njegova proizvodnja je na trećem mestu, posle pšenice i kukuruza. Upotreba ječma je za proizvodnju piva, slada, hleba, stočne hrane, ali i kao celo zrno za potrošnju u domaćinstvima i ishrani stoke.</br></br></p>
            `,
            description_meta : `Cena ječma na pijaci, cena ječma po toni i džaku, prodaja ječma na veliko, ponuda i potražnja ječma na berzi i tržištu, trenutna cena ječma po gradovima i krajevima u Srbiji`,
            alt: descriptionAltMarket('stočnog ječma'),
            description : descriptionMarket.srPath('stočnog ječma'),
            description_path : descriptionMarket.srPath('stocnog jecma'),
            title_path : descriptionMarket.srPath('zitarica'),
            value: "stočni ječam",
            value_path: "stocni jecam",
            catgeory_path: "zitarice",
            text_other: 'Ako želite da pogledate cene u gazdinstvima, silosu i maloprodaji kliknite na cene po nedeljama',
            title_search : 'stocnog jecma',
            title_search_re : 'stočnog ječma',
            avatar: 'st',
            img : FindIcon.find('Stočni ječam').img2,
            color : FindIcon.find('Stočni ječam').color,      
            stips_category : 4,
            ads_category: 'Žitarice',
            stips_source : 8,
            catgeory: 'žitarice',

        },
        {
            food : false,

            id: 6,
            description_page: `<p>Cena stočnog brašna na pijaci u Srbiji zavisi od kvaliteta vršidbe pšenice, rodne godine, jer ono predstavlja nus proizvod mlevenja pšenice. Prodaja stočnog brašna isključivo je po džakovima na malo (džak od 10, 20, 30, 50 kg).</br></br></p>

            <p>Cena stočnog brašna varira od pijace do pijace, kraja u Srbiji (cena stočnog brašna u Vojvodini se razlikuje od cene stočnog brašna u istočnoj ili zapadnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
            
            <p>U sastav stočnog brašna ulaze mekinje i sitno izlomljeno pšenično zrno. Njegova upotreba je u stočnoj ishrani, pokazala se kao dobra i jako kvalitetna hrana za krave i stoku.</br></br></p>
            `,
            description_meta : `Cena stočnog brašna na pijaci, cena stočnog brašna po džaku, trenutna cena stočnog brašna po gradovima i krajevima u Srbiji, stočno brašno za krave i stoku.`,
            alt: descriptionAltMarket('stočnog brašna'),
            description : descriptionMarket.srPath('stočnog brašna'),
            description_path : descriptionMarket.srPath('stocnog brasna'),
            title_path : descriptionMarket.srPath('zitarica'),
            value: "stočno brašno",
            value_path: "stocno brasno",
            title_search : 'stocnog brasna',
            title_search_re : 'stočnog brašna',
            avatar: 'st',
            img : FindIcon.find('Stočno brašno').img2,
            color : FindIcon.find('Stočno brašno').color,
            stips_category : 4,
            ads_category: 'Žitarice',
            stips_source : 8,
            catgeory: 'žitarice',
            catgeory_path: "zitarice",
            text_other: 'Ako želite da pogledate cene u gazdinstvima, silosu i maloprodaji kliknite na cene po nedeljama',


        },
        {
        
            food : false,
            id: 7,
            description_page: `<p>Cena dunja na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje dunja na svetskoj berzi, da li je cena na veliko, da li je dunja za rakiju ili sok. </br></br></p>

            <p>Cena varira od pijace do pijace, koja je sorta dunje, kraja u Srbiji (cena dunja u Vojvodini se razlikuje od cene dunja u istočnoj ili zapadnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
            
            <p>U Srbiji se dunja sadi i gaji i obrađuje za pravljenje sokova, džemova, pekmeza, marmelada, slatkog, kompota, sirupa, želea, pečenje rakije, u ređim slučajevima plod dunje se jede svež, neobrađen. Dunja je jako zdravo i lekovito voće, u Srbiji se godišnje proizvede oko 10 000 tona dunje. Dunja se isključivo prodaje po kilogramu težine.</br></br></p>
            `,
            description_meta : `Cena dunja na pijaci, cena dunja na veliko, ponude i potražnje dunja na svetskoj berzi, trenutna cena dunja po gradovima i krajevima u Srbiji.`,
            value : 'dunja',
            value_path : 'dunja',
            alt: descriptionAltMarket('dunje'),
            title_path : descriptionMarket.srPath('voca'),
            description: descriptionMarket.srPath('dunje'),
            description_path: descriptionMarket.srPath('dunje'),
            img : FindIcon.find('Dunja').img2,
            color: FindIcon.find('Dunja').color,
            stips_category : 1,
            ads_category: 'Voće',
            stips_source : 1,
            catgeory: 'voće',
            catgeory_path: 'voce',
            text_other: 'Ako želite da pogledate cene na kvantaškim pijacama po nedeljama',
            title_search : 'dunje',
            title_search_re : 'dunje',
        },          
            {
                id: 8,
                description_page: `<p>Cena grožđa na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje grožđa na svetskoj berzi, da li je cena na veliko, da li je grožđe za rakiju ili je grožđe za vino. </br></br></p>

                <p>Cena varira od pijace do pijace, koja je sorta grožđa, kraja u Srbiji (cena grožđa u Vojvodini se razlikuje od cene grožđa u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p>U Srbiji se grožđe, vinova loza sadi i gaji i obrađuje za pravljenje vina, sokova, slatkog, sirupa, želea, pečenje rakije, suvo grožđe, ali grožđe se jede i sveže. Grožđe je plod vinove loze. Grožđe se isključivo prodaje po kilogramu težine. Grožđe je u većini slučajeva crno, belo ili roze.</br></br></p>
                `,
                description_meta : `Cena grožđa na pijaci, cena grožđa na veliko, ponude i potražnje grožđa na svetskoj berzi, trenutna cena grožđa po gradovima i krajevima u Srbiji.`,
                food : false,
                value : 'grožđe',
                value_path : 'grozdje',
                alt: descriptionAltMarket('grožđa'),
                title_path : descriptionMarket.srPath('voca'),
                description:  descriptionMarket.srPath('grožđa'),
                description_path:  descriptionMarket.srPath('grozdja'),
                img : FindIcon.find('Grožđe').img2,             
                color: FindIcon.find('Grožđe').color,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory: 'voće',
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                title_search : 'grozdja',
                title_search_re : 'grožđa',
            },       
            {
                id: 9,
                description_page: `<p>Cena breskve na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje breskve na svetskoj berzi, da li je cena na veliko, da li je breskva za džemove, pekmeze, rakiju. </br></br></p>

                <p>Cena varira od pijace do pijace, koja je sorta breskve, kraja u Srbiji (cena breskve u Vojvodini se razlikuje od cene breskve u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p> U Srbiji se breskva sadi i gaji i obrađuje za pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa, pečenje rakije, likera, ali breskve se jedu i sveže. Breskva je plod, drvo iz familije ruža. Breske se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena breskve na pijaci, cena breskve na veliko, ponude i potražnje breskve na svetskoj berzi, trenutna cena breskve po gradovima i krajevima u Srbiji.`,
                food : false,
                value : 'breskva',
                value_path : 'breskva',
                alt: descriptionAltMarket('breskvi'),
                description: descriptionMarket.srPath('breskvi'),
                title_path : descriptionMarket.srPath('voca'),
                description_path: descriptionMarket.srPath('breskvi'),
                img : FindIcon.find('Breskva').img2,
                color: FindIcon.find('Breskva').color,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'breskvi',
                title_search_re : 'breskvi',

            },
            {
                id: 10,
                description_page: `<p>Cena borovnice na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje borovnice na svetskoj berzi, da li je cena na veliko. </br></br></p>

                <p>Cena varira od pijace do pijace, kraja u Srbiji (cena borovnice u zapadnoj Srbiji se razlikuje od cene borovnice u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p> U Srbiji se borovnica nalazi u šumskom području, ali se sadi i gaji i obrađuje za pravljenje sokova, čajeva, marmelada, džemova, pekmeza, slatkog, sirupa, likera, ali borovnice se jedu i sveže. Borovnica se naziva i crna jagoda. Borovnice se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena borovnice na pijaci, otkupna cena borovnice, ponude i potražnje borovnice na svetskoj berzi, trenutna cena borovnice po gradovima i krajevima u Srbiji.`,
                food : false,
                value : 'borovnica',
                value_path : 'borovnica',
                alt: descriptionAltMarket('borovnice'),
                description: descriptionMarket.srPath('borovnice'),
                title_path : descriptionMarket.srPath('voca'),                           
                description_path: descriptionMarket.srPath('borovnice'),                           
                img : FindIcon.find('Borovnica').img2,
                color: FindIcon.find('Borovnica').color,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'borovnice',
                title_search_re : 'borovnice',

            },
           
            {
               
                id: 11,
                description_page: `<p>Cena lešnika na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje lešnika na svetskoj berzi, da li je cena na veliko, da li je lešnik očišćen ili je ceo u ljuski.</br></br></p>

                <p>Cena varira od pijace do pijace, kraja u Srbiji (cena lešnika u zapadnoj Srbiji se razlikuje od cene lešnika u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p>U Srbiji se lešnik nalazi u šumskom području, ali se sadi i gaji i obrađuje za pravljenje konditorskih proizvoda, pravljenje čokolada i čokoladnih proizvoda, pravljenja kolača i torti, ali očišćeni lešnici se jedu i sveži. Lešnik je plod leske. Lešnici se prodaju i otkupljuju uglavnom po kilogramu težine očišćenog lešnika.</br></br></p>
                `,
                description_meta : `Cena lešnika na pijaci, otkupna cena lešnika, cena očišćenih lešnika, ponude i potražnje lešnika na svetskoj berzi, trenutna cena lešnika po gradovima i krajevima u Srbiji.`,
                food : false,
                value : 'lešnik',
                value_path : 'lesnik',
                alt: descriptionAltMarket('lešnika'),
                description: descriptionMarket.srPath('lešnika'),
                title_path : descriptionMarket.srPath('voca'),
                description_path: descriptionMarket.srPath('lesnika'),
                img : FindIcon.find('Lešnik').img2,
                color : FindIcon.find('Lešnik').color,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'lesnika',
                title_search_re : 'lešnika',

            },
            {
                id: 12,
                description_page: `<p>Cena šljiva na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje šljiva na svetskoj berzi, da li je cena na veliko, da li je šljiva za rakiju, džemove, pekmeze, kompote ili je suva šljiva.</br></br></p>

                <p>Cena varira od pijace do pijace, koja je sorta šljive, kraja u Srbiji (cena šljive u Vojvodini se razlikuje od cene šljive u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p>U Srbiji se šljiva sadi i gaji i obrađuje za pravljenje suve šljive, pečenje rakije, ali i pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa, ali šljive se jedu i sveže i suve. Šljive se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena šljiva na pijaci, cena šljiva na veliko, cena suvih šljiva, ponude i potražnje šljiva na svetskoj berzi, trenutna cena šljiva po gradovima i krajevima u Srbiji.`,
                food : false,
                value : 'šljiva',
                value_path : 'sljiva',
                alt: descriptionAltMarket('šljiva'),
                description:  descriptionMarket.srPath('šljiva'),
                title_path : descriptionMarket.srPath('voca'),
                description_path:  descriptionMarket.srPath('sljiva'),
                img : FindIcon.find('Šljiva').img2,
                color : FindIcon.find('Šljiva').color,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'sljiva',
                title_search_re : 'šljiva',
            },
            {
                id: 13,
                description_page: `<p>Cena kruške na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje krušaka na svetskoj berzi, da li je cena na veliko, da li je kruška za rakiju, džemove, kompote.</br></br></p>

                <p>Cena varira od pijace do pijace, koja je sorta kruške, kraja u Srbiji (cena kruške u Vojvodini se razlikuje od cene kruške u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p> U Srbiji se kruška sadi i gaji i obrađuje za pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa,pečenje rakije, ali kruške se jedu i sveže. Postoji oko 35 vrsta krušaka. Kruške se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena kruške na pijaci, cena kruške na veliko, ponude i potražnje krušaka na svetskoj berzi, trenutna cena kruške po gradovima i krajevima u Srbiji.`,
                alt: descriptionAltMarket('krušaka'),
                description : descriptionMarket.srPath('krušaka'),
                title_path : descriptionMarket.srPath('voca'),
                description_path : descriptionMarket.srPath('krusaka'),
                food : false,
                value: "kruška",
                value_path: "kruska",
                avatar: 'kr',
                color : FindIcon.find('Kruška').color,
                img : FindIcon.find('Kruška').img2,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'krusaka',
                title_search_re : 'krušaka',
            },          
             {
                id: 14,
                description_page: `<p>Cena jabuka na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje jabuka na svetskoj berzi, da li je cena na veliko, da li je jabuka za rakiju, sokove, pekmeze, kompote.</br></br></p>

                <p>Cena varira od pijace do pijace, koja je sorta jabuke, kraja u Srbiji (cena jabuke u Vojvodini se razlikuje od cene jabuke u istočnoj ili zapadnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p>U Srbiji se jabuka sadi i gaji i obrađuje za pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa, pečenje rakije, ali jabuke se jedu i sveže. Postoje razne vrsta jabuka, ali najpoznatije su ajdared, zlatni delišes, greni smit, jonagold, mucu, melrouz. U Srbiji se godišnje proizvede oko 200 000 tona jabuka. Jabuke se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena jabuka na pijaci, cena jabuka na veliko, ponude i potražnje jabuka na svetskoj berzi, trenutna cena jabuka po gradovima i krajevima u Srbiji.`,
                alt: descriptionAltMarket('jabuka'),
                title_path : descriptionMarket.srPath('voca'),
                description : descriptionMarket.srPath('jabuka'),
                description_path : descriptionMarket.srPath('jabuka'),
                food : false,
                value: "jabuka",
                value_path: "jabuka",
                avatar: 'ja',
                color : FindIcon.find('Jabuka').color,
                img : FindIcon.find('Jabuka').img2,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'jabuka',
                title_search_re : 'jabuka',
            },
            
            {
                id: 15,
                description_page: `<p>Cena kupina na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje kupina na svetskoj berzi, da li je cena na veliko, da li je kupina sveža za jelo, za sok, za slatko.</br></br></p>

                <p>Cena varira od pijace do pijace, koja je sorta kupina, kraja u Srbiji (cena kupina u Vojvodini se razlikuje od cene kupina u centralnoj ili južnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p>U Srbiji se kupina sadi i gaji i obrađuje za jelo sveže kupine, pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa, kupinova vina. U Srbiji se kupine dele na domaće i na šumske kupine. Kupine se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena kupina na pijaci, cena kupina na veliko, ponude i potražnje kupina na svetskoj berzi, trenutna cena kupina po gradovima i krajevima u Srbiji.
                `,
                alt: descriptionAltMarket('kupina'),
                description : descriptionMarket.srPath('kupina'),
                title_path : descriptionMarket.srPath('voca'),
                description_path : descriptionMarket.srPath('kupina'),
                food : false,
                value: "kupina",
                value_path: "kupina",
                avatar: 'an',
                color : FindIcon.find('Kupina').color,
                img : FindIcon.find('Kupina').img2,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'kupina',
                title_search_re : 'kupina',

            },
            {
                id: 16,
                description_page: `<p>Cena malina na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje malina na svetskoj berzi, da li je cena na veliko, da li je malina sveža za jelo, za sok, za slatko.</br></br></p>

                <p>Cena varira od pijace do pijace, koja je sorta malina, kraja u Srbiji (cena malina u Vojvodini se razlikuje od cene malina u centralnoj ili istočnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p>U Srbiji se malina sadi i gaji i obrađuje za jelo sveže maline, pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa. U Srbiji se maline sve više sade u plastenicima i čuvaju u hladnjačama. Maline se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena malina na pijaci, cena malina na veliko, ponude i potražnje malina na svetskoj berzi, trenutna cena malina po gradovima i krajevima u Srbiji.`,
                alt: descriptionAltMarket('malina'),
                description : descriptionMarket.srPath('malina'),
                title_path : descriptionMarket.srPath('voca'),
                description_path : descriptionMarket.srPath('malina'),
                food : false,
                value: "malina",
                value_path: "malina",
                avatar: 'an',
                color : FindIcon.find('Malina').color,
                img : FindIcon.find('Malina').img2,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'malina',
                title_search_re : 'malina',

            },
            {
                id: 17,
                description_page: `<p>Cena trešnje na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje trešanja na svetskoj berzi, da li je cena na veliko, da li je trešnja sveža za jelo, sokove, džemove, kompote.</br></br></p>

                <p>Cena varira od pijace do pijace, koja je sorta trešnje, kraja u Srbiji (cena trešanja u Vojvodini se razlikuje od cene trešanja u istočnoj ili južnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p>U Srbiji se trešnja sadi i gaji i obrađuje za pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa, pečenje rakije, ali trešnje se u većini slučajeva jedu i sveže. U Srbiji su trešnje sezonsko voće tokom kasnog proleća i leta. Trešnje se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena trešnje na pijaci, cena trešnje na veliko, ponude i potražnje trešanja na svetskoj berzi, trenutna cena trešnje po gradovima i krajevima u Srbiji.`,
                alt: descriptionAltMarket('trešanja'),
                description : descriptionMarket.srPath('trešanja'),
                title_path : descriptionMarket.srPath('voca'),
                description_path : descriptionMarket.srPath('tresanja'),
                food : false,
                value: "trešnja",
                value_path: "tresnja",
                avatar: 'an',
                color : FindIcon.find('Trešnja').color,
                img : FindIcon.find('Trešnja').img2,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'tresanja',
                title_search_re : 'trešanja',

            },
            {
                id: 18,
                description_page: `<p>Cena nektarina na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje nektarina na svetskoj berzi, da li je cena na veliko, da li je nektarina za džemove, pekmeze, kompote. </br></br></p>

                <p>Cena varira od pijace do pijace, koja je sorta nektarine, kraja u Srbiji (cena nektarine u Vojvodini se razlikuje od cene nektarine u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p> U Srbiji se nektarina sadi i gaji i obrađuje za pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa, pečenje rakije, likera, ali nektarine se jedu i sveže. Nektarina je podvrsta breskve, plod, drvo iz familije ruža. Nektarine se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena nektarina na pijaci, cena nektarina na veliko, ponude i potražnje nektarina na svetskoj berzi, trenutna cena nektarina po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('nektarina'),
                description : descriptionMarket.srPath('nektarina'),
                title_path : descriptionMarket.srPath('voca'),
                description_path : descriptionMarket.srPath('nektarina'),
                value: "nektarina",
                value_path: "nektarina",
                avatar: 'ne',
                color : FindIcon.find('Nektarina').color,
                img : FindIcon.find('Nektarina').img2,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,                 
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'nektarina',
                title_search_re : 'nektarina',
            },
            {
                id: 19,
                description_page: `<p>Cena višnje na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje višanja na svetskoj berzi, da li je cena na veliko, da li je višnja sveža za jelo, sokove, džemove, kompote.</br></br></p>

                <p> Cena varira od pijace do pijace, koja je sorta višnje, kraja u Srbiji (cena višanja u Vojvodini se razlikuje od cene višanja u zapadnoj ili južnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p> U Srbiji se višnja sadi i gaji i obrađuje za pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa, pečenje rakije, ali višnje se u većini slučajeva jedu i sveže. U Srbiji su višnje sezonsko voće tokom kasnog proleća i leta. Višnje se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena višnje na pijaci, cena višnje na veliko, ponude i potražnje višanja na svetskoj berzi, trenutna cena višnje po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('višanja'),
                description : descriptionMarket.srPath('višanja'),
                title_path : descriptionMarket.srPath('voca'),
                description_path : descriptionMarket.srPath('visanja'),
                value: "višnja",
                value_path: "visnja",
                avatar: 'an',
                color : FindIcon.find('Višnja').color,
                img : FindIcon.find('Višnja').img2,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'visanja',
                title_search_re : 'višanja',
            },
            {
                id: 20,
                description_page: `<p>Cena oraha na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje oraha na svetskoj berzi, da li je cena na veliko, da li je orah očišćen ili je ceo u ljuski.</br></br></p>

                <p>Cena varira od pijace do pijace, kraja u Srbiji (cena oraha u zapadnoj Srbiji se razlikuje od cene oraha u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p>U Srbiji se orah nalazi uz kuće, oranice, livade, ali se sadi i gaji i obrađuje za pravljenje konditorskih proizvoda, pravljenje čokolada i čokoladnih proizvoda, pravljenja kolača i torti, ali očišćeni orasi se jedu i sveži. Orasi se prodaju i otkupljuju uglavnom po kilogramu težine očišćenog oraha ili oraha u ljusci.</br></br></p>
                `,
                description_meta : `Cena oraha na pijaci, otkupna cena oraha, cena očišćenih oraha, ponude i potražnje oraha na svetskoj berzi, trenutna cena oraha po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('oraha'),
                description : descriptionMarket.srPath('oraha'),
                title_path : descriptionMarket.srPath('voca'),
                description_path : descriptionMarket.srPath('oraha'),
                value: "orah",
                value_path: "orah",
                avatar: 'ne',
                color : FindIcon.find('Orah').color,
                img : FindIcon.find('Orah').img2,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'oraha',
                title_search_re : 'oraha',

            },
            {
                id: 21,
                description_page: `<p>Cena smokve na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje smokava na svetskoj berzi, da li je cena na veliko, da li je smokva sveža za jelo, da li je suva smokva, za džemove, za slatko.</br></br></p>

                <p>Cena varira od pijace do pijace, koja je sorta smokve, suva smokva, kraja u Srbiji (cena smokava u Vojvodini se razlikuje od cene smokava u centralnoj ili južnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p>U Srbiji se smokva sadi i gaji i obrađuje za sušenje smokve ili za jelo sveže smokve, pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa. U Srbiji se smokve jedu sveže ili sušene. Smokve se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena smokve na pijaci, cena smokve na veliko, ponude i potražnje smokava na svetskoj berzi, trenutna cena smokve po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('smokve'),
                description : descriptionMarket.srPath('smokve'),
                title_path : descriptionMarket.srPath('voca'),
                description_path : descriptionMarket.srPath('smokve'),
                value: "smokva",
                value_path: "smokva",
                avatar: 'sm',
                color : FindIcon.find('Smokva').color,
                img : FindIcon.find('Smokva').img2,
                stips_category : 1,
                ads_category: 'Voće',
                 stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'smokve',
                title_search_re : 'smokve',

            },
            {
                id: 22,
                description_page: `<p>Cena kajsija na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje kajsija na svetskoj berzi, da li je cena na veliko, da li je kajsija za rakiju, džemove, pekmeze, kompote. </br></br></p>

                <p>Cena varira od pijace do pijace, koja je sorta kajsije, kraja u Srbiji (cena kajsije u Vojvodini se razlikuje od cene kajsije u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p>U Srbiji se kajsija sadi i gaji i obrađuje za pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa, pečenje rakije, likera, ali kajsije se jedu i sveže. Kajsija se još naziva i marelica. Kajsije se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena kajsija na pijaci, cena kajsija na veliko, ponude i potražnje kajsija na svetskoj berzi, trenutna cena kajsija po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('kajsija'),
                description : descriptionMarket.srPath('kajsija'),
                title_path : descriptionMarket.srPath('voca'),
                description_path : descriptionMarket.srPath('kajsija'),
                value: "kajsija",
                value_path: "kajsija",
                avatar: 'ks',
                color : FindIcon.find('Kajsija').color,
                img : FindIcon.find('Kajsija').img2,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'kajsija',
                title_search_re : 'kajsija',

            },
            {
                id: 23,
                description_page: `<p>Cena jagoda na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje jagoda na svetskoj berzi, da li je cena na veliko, da li je jagoda sveža za jelo, za džemove, za slatko.</br></br></p>

                <p>Cena varira od pijace do pijace, koja je sorta jagoda, sezona jagoda, kraja u Srbiji (cena jagoda u Vojvodini se razlikuje od cene jagoda u zapadnoj ili južnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                
                <p>U Srbiji se jagoda sadi i gaji i obrađuje za jelo sveže jagode, pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa. U Srbiji se jagode dele na domaće i na šumske jagode. Jagode se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                `,
                description_meta : `Cena jagoda na pijaci, cena jagoda na veliko, ponude i potražnje jagoda na svetskoj berzi, trenutna cena jagoda po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('jagoda'),
                description : descriptionMarket.srPath('jagoda'),
                title_path : descriptionMarket.srPath('voca'),
                description_path : descriptionMarket.srPath('jagoda'),
                value: "jagoda",
                value_path: "jagoda",
                avatar: 'ks',
                color : FindIcon.find('Jagoda').color,
                img : FindIcon.find('Jagoda').img2,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'jagoda',
                title_search_re : 'jagoda',

            },
            {
                id: 24,
                description_page: `<p>Cena bikova na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje bikova na tržištu. Prodaja i kupovina bikova odnose se na bikove teže od pola tone. Bikove uglavnom otkupljuju klanice.</br></br></p>

                <p>Cena varira od stočne pijace do pijace, rase bikova, kraja u Srbiji (cena bikova u Vojvodini se razlikuje od cene bikova u istočnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p>U Srbiji se bikovi uzgajaju i tove za osemenjavanje, klanje i dalju prodaju. Određeni instituti uzgajaju bikove radi prodaje njihovog semena i osemenjavanja krava. Kada se bik kastrira, on postaje – vo.</br></br></p>
                `,
                description_meta : `Cena bikova na stočnoj pijaci, cena semena bika, ponude i potražnje bikova na tržištu, trenutna cena bikova po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('bikova'),
                description : descriptionMarket.srPath('bikova'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('bikova'),
                value: "bikovi",
                value_path: "bikovi",
                avatar: 'bi',
                img : FindIcon.find('Bikovi').img2,
                color : FindIcon.find('Bikovi').color,
                stips_category : 3,
                stips_source : 4,
                catgeory: 'stoka',
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                title_search : 'bikova',
                title_search_re : 'bikova',


            },
            {
                id: 25,
                description_page: `<p>Cena jagnjadi na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje jagnjadi na tržištu. Jagnjad otkupljuju klanice na veću količinu jagnjadi, potom je zastupljena pojedinačna prodaja jagnjadi.</br></br></p>

                <p>Cena varira od stočne pijace do pijace, rase jagnjadi i ovaca, kraja u Srbiji (cena jagnjadi u Vojvodini se razlikuje od cene jagnjadi u centralnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p> U Srbiji se jagnjad uzgaja i tovi za proširenje i razvoj postojećeg fonda ovaca i dalju prodaju jagnjadi. Jagnjad se prodaje po kilogramu težine, ali i po količini ukoliko se prodaje više od jednog jagnjeta. Po definiciji kod domaćina, jagnje je mladunče ovce staro do pola godine, do zalučenja i ima oko 30 kg.</br></br></p>
                `,
                description_meta : `Cena jagnjadi na stočnoj pijaci, prodaja i otkup jagnjadi, ponude i potražnje jagnjadi na tržištu, trenutna cena jagnjadi po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('jagnjadi'),
                description : descriptionMarket.srPath('jagnjadi'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('jagnjadi'),
                value: "jagnjad",
                value_path: "jagnjad",
                avatar: 'ja',
                img : FindIcon.find('Jagnjad').img2,
                color : FindIcon.find('Jagnjad').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'jagnjadi',
                title_search_re : 'jagnjadi',

            },
            {
                id: 26,
                description_page: `<p>Cena dviski na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje na tržištu. Dviske se prodaju i otkupljuju radi započinjanja ili proširenja farme ovaca.</br></br></p>

                <p>Cena varira od stočne pijace do pijace, kraja u Srbiji (cena dviski u Vojvodini se razlikuje od cene dviski u istočnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p>U Srbiji se dviske uzgajaju za proširenje i razvoj postojećeg fonda ovaca i za dalju prodaju dviski. Dviske se uglavnom prodaju po količini i cena se tako formira. U ređim slučajevima prodaju se po kilogramu žive vage. Po definiciji kod domaćina, dviska je mlada ovca stara od godinu dana do prvog jagnjenja. Dvizak je muško grlo ovce od druge godine do parenja.</br></br></p>
                `,
                description_meta : `Cena dviski na stočnoj pijaci, prodaja i otkup dviski i mladih ovaca, ponude i potražnje dviski na tržištu, trenutna cena dviski po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('dviski'),
                description : descriptionMarket.srPath('dviski'), 
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('dviski'),
                value: "dviske",
                value_path: "dviske",
                avatar: 'dv',
                img : FindIcon.find('Dviske').img2,
                color : FindIcon.find('Dviske').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'dviski',
                title_search_re : 'dviski',
                
            },
            {
                id: 27,
                description_page: `<p>Cena jaradi na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje jaradi na tržištu. Jarad otkupljuju klanice na veću količinu jaradi, potom je zastupljena pojedinačna prodaja jaradi.</br></br></p>

                <p>Cena varira od stočne pijace do pijace, rase jaradi, kraja u Srbiji (cena jaradi u Vojvodini se razlikuje od cene jaradi u južnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p>U Srbiji se jarad uzgaja i tovi za proširenje i razvoj postojećeg fonda koza i dalju prodaju jaradi. Jarad se prodaje po kilogramu težine, ali i po količini ukoliko se prodaje više od jednog jareta. Po definiciji kod domaćina, jare je mladunče koze, do zalučenja i ima oko 25kg do 30 kg.</br></br></p>
                `,
                description_meta : `Cena jaradi na stočnoj pijaci, prodaja i otkup jaradi, rase jaradi, ponude i potražnje jaradi na tržištu, trenutna cena jaradi po gradovima i krajevima u Srbiji.`,
            food : false,
            alt: descriptionAltMarket('jaradi'),
            description : descriptionMarket.srPath('jaradi'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('jaradi'),
                value: "jarad",
                value_path: "jarad",
                avatar: 'ja',
                img : FindIcon.find('Jarad').img2,
                color : FindIcon.find('Jarad').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'jaradi',
                title_search_re : 'jaradi',

            },
            {
                id: 28,
                description_page: `<p>Cena junadi na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje junadi na tržištu. Prodaja i kupovina junadi odnosi se uglavnom na junad za tov i klanje i za dalju reprodukciju. Junad uglavnom otkupljuju klanice ili pojedinačni slučajevi domaćinstava za priplod i meso.</br></br></p>

                <p>Cena varira od stočne pijace do pijace, težine junadi, kraja u Srbiji (cena junadi u Vojvodini se razlikuje od cene junadi u istočnoj ili južnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p>U Srbiji se junad uzgajaju za tov, reprodukciju, telenje, mleko, i za dalju prodaju. Kupci su uglavnom klanice ili farme krava, takođe i pojedinačna domaćinstva. Cena se u većini slučajeva formira po kilogramu žive vage. June, junica, junac, junad su subadultna grla ili grla koja nisu bila u reprodukciji.</br></br></p>
                `,
                description_meta : `Cena junadi na stočnoj pijaci, cena junadi za tov i klanje, tovna junad cena, ponude i potražnje junadi na tržištu, trenutna cena junadi po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('junadi'),
                description : descriptionMarket.srPath('junadi'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('junadi'),
                value: "junad",
                value_path: "junad",
                avatar: 'ju',
                img : FindIcon.find('Junad').img2,
                color : FindIcon.find('Junad').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'junadi',
                title_search_re : 'junadi',

            },
            {
                id: 29,
                description_page: `<p>Cena koza na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje koza na tržištu. Prodaja i kupovina koza odnosi se uglavnom na koze za klanje, zatim koze za dalji priplod i proširenje farme koza. Koze otkupljuju klanice, farme koza ili pojedinačni slučajevi domaćinstava za klanje ili priplod.</br></br></p>

                <p>Cena varira od stočne pijace do pijace, rase koza, kraja u Srbiji (cena koza u Vojvodini se razlikuje od cene koza u južnoj ili centralnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p>U Srbiji se koze uzgajaju za mleko, jarenje i za dalju prodaju. Kupci su uglavnom klanice, farme koza, takođe i pojedinačna domaćinstva koja uzgajaju koze. Cena se u većini slučajeva formira po kilogramu žive vage ili po pojedinačnoj kozi. </br></br></p>
                `,
                description_meta : `Cena koza na stočnoj pijaci, cena mlečnih koza, rase koza, ponude i potražnje koza na tržištu, trenutna cena koza po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('koza'),
                description : descriptionMarket.srPath('koza'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('koza'),
                value: "koze",
                value_path: "koze",
                avatar: 'ko',
                img : FindIcon.find('Koze').img2,
                color : FindIcon.find('Koze').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'koza',
                title_search_re : 'koza',

            },
            {
                id: 30,
                description_page: `<p>Cena krava na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje krava na tržištu. Prodaja i kupovina krava odnosi se uglavnom na krave za klanje, u retkim slučajevima za dalju reprodukciju. Krave uglavnom otkupljuju klanice ili pojedinačni slučajevi domaćinstava za priplod i meso.</br></br></p>

                <p>Cena varira od stočne pijace do pijace, rase krava, kraja u Srbiji (cena krava u Vojvodini se razlikuje od cene krava u istočnoj ili južnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p>U Srbiji se krave uzgajaju za reprodukciju, telenje, mleko, kada krava ostari i ne može ostati steona, nakon nekoliko godina ona se prodaje za klanje. Ponekad se krava prodaje sa teletom ili steona krava i tu su kupci farme krava ili pojedinačna domaćinstva.</br></br></p>
                `,
                description_meta : `Cena krava na stočnoj pijaci, cena krava za klanje, cena steonih krava, ponude i potražnje krava na tržištu, trenutna cena krava po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('krava za klanje'),
                description : descriptionMarket.srPath('krava za klanje'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('krava za klanje'),
                value: "krave za klanje",
                value_path: "krave za klanje",
                avatar: 'kr',
                img : FindIcon.find('Krave za klanje').img2,
                color : FindIcon.find('Krave za klanje').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'krava za klanje',
                title_search_re : 'krava za klanje',

            },
            {
                id: 31,
                description_page: `<p>Cena teladi na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje teladi na tržištu. Prodaja i kupovina teladi odnosi se uglavnom na telad za klanje, potom telad za tov, zatim telad za dalju reprodukciju i proširenje farme krava. Telad otkupljuju klanice, farme krava ili pojedinačni slučajevi domaćinstava za tov, klanje ili priplod.</br></br></p>

                <p>Cena varira od stočne pijace do pijace, rase teladi, kraja u Srbiji (cena teladi u Vojvodini se razlikuje od cene teladi u istočnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p>U Srbiji se telad uzgajaju za tov, reprodukciju i za dalju prodaju. Kupci su uglavnom klanice, farme krava, takođe i pojedinačna domaćinstva. Cena se u većini slučajeva formira po kilogramu žive vage, ređe po pojedinačnom teletu. Tele je mladunče krave, oko 100 kg do 150 kg.</br></br></p>
                `,
                description_meta : `Cena teladi na stočnoj pijaci, cena teladi za tov, ponude i potražnje teladi na tržištu, trenutna cena teladi po gradovima i krajevima u Srbiji.`,
            food : false,
            alt: descriptionAltMarket('teladi'),
            description : descriptionMarket.srPath('teladi'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('teladi'),
                value: "telad",
                value_path: "telad",
                avatar: 'te',
                img : FindIcon.find('Telad').img2,
                color : FindIcon.find('Telad').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'teladi',
                title_search_re : 'teladi',

            },
            {
                id: 32,
                description_page: `<p>Cena ovaca na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje na tržištu. Ovce se prodaju i otkupljuju radi započinjanja ili proširenja farme ovaca, u ređim slučajevima otkup vrše i klanice ili postoji pojedinačna prodaja radi mesa.</br></br></p>

                <p> Cena varira od stočne pijace do pijace, rase ovaca, kraja u Srbiji (cena ovaca u Vojvodini se razlikuje od cene ovaca u centralnoj ili južnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p> U Srbiji se ovce uzgajaju za dobijanje jaganjaca i njihovu dalju prodaju, proširenje i razvoj postojećeg fonda ovaca, za dobijanje vune i mesa. Ovce se uglavnom prodaju po količini i cena se tako formira ili se prodaju po kilogramu žive vage. Po definiciji kod domaćina, ovca je žensko priplodno grlo posle prvog jagnjenja.</br></br> </p>
                `,
                description_meta : `Cena ovaca na stočnoj pijaci, prodaja i otkup ovaca, cena rase ovaca, ponude i potražnje ovaca na tržištu, trenutna cena ovaca po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('ovaca'),
                description : descriptionMarket.srPath('ovaca'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('ovaca'),
                value: "ovca",
                value_path: "ovca",
                avatar: 'ov',
                img : FindIcon.find('Ovca').img2,
                color : FindIcon.find('Ovca').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'ovaca',
                title_search_re : 'ovaca',
            },
            {
                id: 33,
                description_page: `<p>Cena krmača na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje krmača na tržištu. Prodaja i kupovina krmača odnosi se uglavnom na krmače za klanje, u retkim slučajevima za dalju reprodukciju. Krmače uglavnom otkupljuju klanice ili pojedinačni slučajevi domaćinstava za priplod i meso.</br></br></p>

                <p> Cena varira od stočne pijace do pijace, rase krmača, kraja u Srbiji (cena krmača u Vojvodini se razlikuje od cene krmača u južnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p> U Srbiji se krmače uzgajaju za reprodukciju, prašenje, meso, a kada krmača ostari i ne može više da se prasi, ona se prodaje za klanje. Cena se u većini slučajeva formira po kilogramu žive vage ili po pojedinačnoj krmači za klanje.</br></br></p>
                `,
                description_meta : `Cena krmača na stočnoj pijaci, cena krmača za klanje, ponude i potražnje krmača za klanje na tržištu, trenutna cena krmača po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('krmača za klanje'),
                description : descriptionMarket.srPath('krmača za klanje'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('krmaca za klanje'),
                value: "krmače za klanje",
                value_path: "krmace za klanje",
                avatar: 'kr',
                img : FindIcon.find('Krmače za klanje').img2,
                color : FindIcon.find('Krmače za klanje').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'krmaca za klanje',
                title_search_re : 'krmača za klanje',

            },
            {
                id: 34,
                description_page: `<p>Cena prasadi na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje prasadi na tržištu. Prasad otkupljuju klanice na veću količinu prasadi, potom je zastupljena pojedinačna prodaja prasadi.</br></br></p>

                <p>Cena varira od stočne pijace do pijace, rase prasadi, kraja u Srbiji (cena prasadi u Vojvodini se razlikuje od cene prasadi u južnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p>U Srbiji se prasad uzgaja i tovi isključivo za dalju prodaju, u ređim slučajevima prodaje se za proširenje i razvoj postojećeg fonda svinja. Prasad se prodaje po kilogramu težine, ali i po količini ukoliko se prodaje više od jednog praseta. Cena se takođe formira na osnovu težine praseta, do 15 kg, 20 kg, 25 kg, 30 kg.</br></br></p>
                `,
                description_meta : `Cena prasadi na stočnoj pijaci, prodaja i otkup prasadi, rase prasadi, ponude i potražnje prasadi na tržištu, trenutna cena prasadi po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('prasadi'),
                description : descriptionMarket.srPath('prasadi'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('prasadi'),
                value: "prasad",
                value_path: "prasad",
                avatar: 'ps',
                img : FindIcon.find('Prasad').img2,
                color : FindIcon.find('Prasad').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'prasadi',
                title_search_re : 'prasadi',

            },
            {
                id: 35,
                description_page: `<p>Cena šilježadi na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje na tržištu. Šilježad se prodaju i otkupljuju radi započinjanja ili proširenja farme ovaca, u ređim slučajevima otkup vrše i klanice ili postoji pojedinačna prodaja radi mesa.</br></br></p>

                <p>Cena varira od stočne pijace do pijace, kraja u Srbiji (cena šilježadi u Vojvodini se razlikuje od cene šilježadi u istočnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p>U Srbiji se šilježad uzgajaju za proširenje i razvoj postojećeg fonda ovaca i za dalju prodaju šilježadi. Šilježad se uglavnom prodaju po količini i cena se tako formira ili se prodaju po kilogramu žive vage. Po definiciji kod domaćina, šilježe je mlada ovca stara od pola godine do godinu dana.</br></br></p>
                `,
                description_meta : `Cena šilježadi na stočnoj pijaci, prodaja i otkup šilježadi i mladih ovaca, ponude i potražnje šilježadi na tržištu, trenutna cena šilježadi po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('šilježadi'),
                description : descriptionMarket.srPath('šilježadi'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('siljezadi'),
                value: "šilježad",
                value_path: "siljezad",
                avatar: 'ps',
                img : FindIcon.find('Šilježad').img2,
                color : FindIcon.find('Šilježad').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'siljezadi',
                title_search_re : 'šilježadi',

            },
            {
                id: 36,
                description_page: `<p>Cena tovljenika, svinja na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje tovljenika na tržištu. Tovljenike, svinje otkupljuju klanice na veću količinu tovljenika, potom je zastupljena pojedinačna prodaja tovljenika.</br></br></p>

                <p> Cena varira od stočne pijace do pijace, kraja u Srbiji (cena tovljenika u Vojvodini se razlikuje od cene tovljenika u južnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p> U Srbiji se svinje, tovljenici uzgajaju i tove isključivo za dalju prodaju, u ređim slučajevima prodaje se za proširenje i razvoj postojećeg fonda svinja. Tovljenici se prodaju isključivo po kilogramu težine. Cena se takođe formira na osnovu težine tovljenika, do 120 kg, preko 120 kg.</br></br></p>
                `,
                description_meta : `Cena svinja, tovljenika na stočnoj pijaci, prodaja i otkup svinja, rase svinja, ponude i potražnje tovljenika na tržištu, trenutna cena svinja, tovljenika po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('tovljenika'),
                description : descriptionMarket.srPath('tovljenika'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('tovljenika'),
                value: "tovljenici",
                value_path: "tovljenici",
                avatar: 'to',
                img : FindIcon.find('Tovljenici').img2,
                color : FindIcon.find('Tovljenici').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'tovljenika',
                title_search_re : 'tovljenika',

            },
            {
                id: 37,
                description_page: `<p>Cena ovnova na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje na tržištu. Ovnovi se isključivo prodaju za priplod na farmi ovaca ili u pojedinačnim slučajevima za domaćinstvo, u ređim slučajevima otkup se vrši za meso.</br></br></p>
 
                <p>Cena varira od stočne pijace do pijace, rase ovnova, kraja u Srbiji (cena ovnova u Vojvodini se razlikuje od cene ovnova u centralnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p> U Srbiji se ovnovi uzgajaju za dobijanje jaganjaca i njihovu dalju prodaju za priplod, proširenje i razvoj postojećeg fonda ovaca. Ovnovi se uglavnom prodaju po grlu, uglavnom je to jedan ovan za priplod i cena se tako formira, jako je redak slučaj prodaje po kilogramu žive vage. Po definiciji kod domaćina, ovan je muško priplodno grlo. Škopac je kastrirani ovan.</br></br></p>
                `,
                description_meta : `Cena ovnova na stočnoj pijaci, prodaja i otkup ovnova za priplod, cena rase ovna za priplod, ponude i potražnje ovnova na tržištu, trenutna cena ovnova po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('ovnova za priplod'),
                description : descriptionMarket.srPath('ovnova za priplod'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('ovnova za priplod'),
                value: "ovnovi za priplod",
                value_path: "ovnovi za priplod",
                avatar: 'op',
                img : FindIcon.find('Ovnovi za priplod').img2,
                color : FindIcon.find('Ovnovi za priplod').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'ovnova za priplod',
                title_search_re : 'ovnova za priplod',
            },
            {
                id: 38,
                description_page: `<p>Cena junica na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje junica na tržištu. Prodaja i kupovina junica odnosi se uglavnom na junice za dalju reprodukciju i proširenje farme krava. Junice za priplod uglavnom otkupljuju farme krava ili pojedinačni slučajevi domaćinstava za priplod.</br></br></p>

                <p>Cena varira od stočne pijace do pijace, da li su junice steone, kraja u Srbiji (cena junica u Vojvodini se razlikuje od cene junica u istočnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p>U Srbiji se junice uzgajaju za reprodukciju, telenje, mleko, i za dalju prodaju. Kupci su uglavnom farme krava, takođe i pojedinačna domaćinstva. Cena se u većini slučajeva formira po grlu, pojedinačnoj junici. Junica se kao mlada krava prodaje kao steona ili ne.</br></br></p>
                `,
                description_meta : `Cena junica na stočnoj pijaci, cena junica za priplod, cena steone junice, ponude i potražnje junica na tržištu, trenutna cena junica po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('priplodnih junica'),
                description : descriptionMarket.srPath('priplodnih junica'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('priplodnih junica'),
                value: "priplodne junice",
                value_path: "priplodne junice",
                avatar: 'pi',
                img : FindIcon.find('Priplodne junice').img2,
                color : FindIcon.find('Priplodne junice').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'priplodnih junica',
                title_search_re : 'priplodnih junica',
            },
            {
                id: 39,
                description_page: `<p>Cena priplodnih nazimica na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje nazimica na tržištu. Prodaja i kupovina nazimica odnosi se uglavnom na nazimice za dalju reprodukciju i proširenje farme svinja. Nazimice za priplod uglavnom otkupljuju farme svinja ili pojedinačni slučajevi domaćinstava za priplod.</br></br></p>

                <p> Cena varira od stočne pijace do pijace, rase nazimica, kraja u Srbiji (cena nazimica u Vojvodini se razlikuje od cene nazimica u istočnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine.</br></br></p>
                
                <p> U Srbiji se nazimice za priplod uzgajaju za reprodukciju, prašenje, i za dalju prodaju. Kupci su uglavnom farme svinja, takođe i pojedinačna domaćinstva. Cena se u većini slučajeva formira po pojedinačnoj nazimici.</br></br></p>
                `,
                description_meta : `Cena nazimica za priplod na stočnoj pijaci, cena priplodnih nazimica, ponude i potražnje nazimica na tržištu, trenutna cena nazimica za priplod po gradovima i krajevima u Srbiji.`,
                food : false,
                alt: descriptionAltMarket('priplodnih nazimica'),
                description : descriptionMarket.srPath('priplodnih nazimica'),
                title_path : descriptionMarket.srPath('stoke'),
                description_path : descriptionMarket.srPath('priplodnih nazimica'),
                value: "priplodne nazimice",
                value_path: "priplodne nazimice",
                avatar: 'pi',
                img : FindIcon.find('Priplodne nazimice').img2,
                color : FindIcon.find('Priplodne nazimice').color,
                stips_category : 3,
                stips_source : 4,
                catgeory_path: 'stoka',
                text_other: 'Ako želite da pogledate cene na stočnim pijacama i klanicama kliknite na cene po nedeljama',
                catgeory: 'stoka',
                title_search : 'priplodnih nazimica',
                title_search_re : 'priplodnih nazimica',
            },
            {
                id: 40,
                description_page: `<p>Cena kivija na pijaci zavisi od rodne godine zemlje odakle se uvozi, ponude i potražnje kivija na tržištu i berzama. Prodaja kivija je na malo po kilogramu težine.</br></br></p>

                <p>Cena kivija varira od pijace do pijace, kraja u Srbiji (cena kivija u Vojvodini se razlikuje od cene kivija u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                
                <p>U Srbiji se kivi uvozi za ljudsku upotrebu, sveži kivi kao voće se jede ili u većini slučajeva konzumira se kao sok od kivija.  Takođe kivi se koristi i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                `,
                description_meta : `Cena kivija na pijaci, cena kivija kilogram, cena kivija danas po gradovima i krajevima u Srbiji.`,
                food : false,
                value : 'kivi',
                value_path : 'kivi',
                alt: descriptionAltMarket('kivija'),
                title_path : descriptionMarket.srPath('juznog voca'),
                description: descriptionMarket.srPath('kivija'),
                description_path: descriptionMarket.srPath('kivija'),
                img : FindIcon.find('Kivi').img2,
                color: FindIcon.find('Kivi').color,
                stips_category : 1,
                ads_category: 'Voće',
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                stips_source : 1,
                title_search : 'kivija',
                title_search_re : 'kivija',
            },
            {
                id: 41,
                description_page: `<p>Cena mandarina na pijaci zavisi od rodne godine zemlje odakle se uvozi, ponude i potražnje mandarina na tržištu i berzama. Prodaja mandarina je na malo po kilogramu težine.</br></br></p>

                <p>Cena mandarina varira od pijace do pijace, kraja u Srbiji (cena mandarina u Vojvodini se razlikuje od cene mandarina u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                
                <p>U Srbiji se mandarine uvoze za ljudsku upotrebu, sveža mandarina kao voće se jede ili u većini slučajeva konzumira se kao sok od mandarina.  Takođe mandarina se koristi i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                `,
                description_meta : `Cena mandarina na pijaci, cena mandarina kilogram, cena mandarina danas po gradovima i krajevima u Srbiji.`,
                food : false,
                value : 'mandarina',
                value_path : 'mandarina',
                alt: descriptionAltMarket('mandarine'),
                title_path : descriptionMarket.srPath('juznog voca'),
                description: descriptionMarket.srPath('mandarine'),
                description_path: descriptionMarket.srPath('mandarine'),
                img : FindIcon.find('Mandarina').img2,
                color: FindIcon.find('Mandarina').color,
                stips_category : 1,
                ads_category: 'Voće',
                stips_source : 1,
                catgeory_path: 'voce',
                text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                catgeory: 'voće',
                title_search : 'mandarine',
                title_search_re : 'mandarine',

            },
                {
                    id: 42,
                    description_page: `<p>Cena grejpfruta na pijaci zavisi od rodne godine zemlje odakle se uvozi, ponude i potražnje grejpfruta na tržištu i berzama. Prodaja grejpfruta je na malo po kilogramu težine.</br></br></p>

                    <p> Cena grejpfruta varira od pijace do pijace, kraja u Srbiji (cena grejpfruta u Vojvodini se razlikuje od cene grejpfruta u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p> U Srbiji se grejpfrut uvozi za ljudsku upotrebu, sveži grejpfrut kao voće se jede ili u većini slučajeva konzumira se kao sok od grejpfruta.  Takođe grejpfrut se koristi i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                    `,
                    description_meta : `Cena grejpfruta na pijaci, cena grejpfruta kilogram, cena grejpfruta danas po gradovima i krajevima u Srbiji.`,
                    food : false,
                    value : 'grejpfrut',
                    value_path : 'grejpfrut',
                    alt: descriptionAltMarket('grejpfruta'),
                    title_path : descriptionMarket.srPath('juznog voca'),
                    description: descriptionMarket.srPath('grejpfruta'),
                    description_path: descriptionMarket.srPath('grejpfruta'),
                    img : FindIcon.find('Grejpfrut').img2,
                    color: FindIcon.find('Grejpfrut').color,
                    stips_category : 1,
                    ads_category: 'Voće',
                    stips_source : 1,
                    catgeory_path: 'voce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    catgeory: 'voće',
                    title_search : 'grejpfruta',
                    title_search_re : 'grejpfruta',

                },
                
                {
                    id: 43,
                    description_page: `<p>Cena limuna na pijaci zavisi od rodne godine zemlje odakle se uvozi, ponude i potražnje limuna na tržištu i berzama. Prodaja limuna je na malo po kilogramu težine.</br></br></p>

                    <p>Cena limuna varira od pijace do pijace, kraja u Srbiji (cena limuna u Vojvodini se razlikuje od cene limuna u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p> U Srbiji se limun uvozi za ljudsku upotrebu, sveži limun kao voće se jede ili u većini slučajeva konzumira se kao sok od limuna.  Takođe limun se koristi i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                    `,
                    description_meta : `Cena limuna na pijaci, cena limuna kilogram, cena limuna danas po gradovima i krajevima u Srbiji.`,
                    food : false,
                    value : 'limun',
                    value_path : 'limun',
                    alt: descriptionAltMarket('limuna'),
                    title_path : descriptionMarket.srPath('juznog voca'),
                    description: descriptionMarket.srPath('limuna'),
                    description_path: descriptionMarket.srPath('limuna'),
                    img : FindIcon.find('Limun').img2,
                    color: FindIcon.find('Limun').color,
                    stips_category : 1,
                    ads_category: 'Voće',
                    stips_source : 1,
                    catgeory_path: 'voce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    catgeory: 'voće',
                    title_search : 'limuna',
                    title_search_re : 'limuna',

                },       
                {
                    id: 44,
                    description_page: `<p>Cena nara na pijaci zavisi od rodne godine zemlje odakle se uvozi, ponude i potražnje nara na tržištu i berzama. Prodaja nara je na malo po kilogramu težine.</br></br></p>

                    <p>Cena nara varira od pijace do pijace, kraja u Srbiji (cena nara u Vojvodini se razlikuje od cene nara u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p> U Srbiji se nar uvozi za ljudsku upotrebu, sveži nar kao voće se jede ili u većini slučajeva konzumira se kao sok od nara.  Takođe nar se koristi i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                    `,
                    description_meta : `Cena nara na pijaci, cena nara kilogram, cena nara danas po gradovima i krajevima u Srbiji.`,
                    food : false,
                    value : 'nar',
                    value_path : 'nar',
                    alt: descriptionAltMarket('nara'),
                    title_path : descriptionMarket.srPath('juznog voca'),
                    description: descriptionMarket.srPath('nara'),
                    description_path: descriptionMarket.srPath('nara'),
                    img : FindIcon.find('Nar').img2,
                    color: FindIcon.find('Nar').color,
                    stips_category : 1,
                    ads_category: 'Voće',
                    stips_source : 1,
                    catgeory_path: 'voce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    catgeory: 'voće',
                    title_search : 'nara',
                    title_search_re : 'nara',

                },     
                {
                    id: 45,
                    description_page: `<p>Cena banana na pijaci zavisi od rodne godine zemlje odakle se uvozi, ponude i potražnje banana na tržištu i berzama. Prodaja banana je na malo po kilogramu težine.</br></br></p>

                    <p>Cena banana varira od pijace do pijace, kraja u Srbiji (cena banana u Vojvodini se razlikuje od cene banana u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p>U Srbiji se banane uvoze za ljudsku upotrebu, sveža banana kao voće se jede ili u većini slučajeva konzumira se kao kaša od banana.  Takođe banana se koristi i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                    `,
                    description_meta : `Cena banana na pijaci, cena banana kilogram, cena banana danas po gradovima i krajevima u Srbiji.`,
                    alt: descriptionAltMarket('banane'),
                    title_path : descriptionMarket.srPath('juznog voca'),
                    description : descriptionMarket.srPath('banane'),
                    description_path : descriptionMarket.srPath('banane'),
                    food : false,
                    value: "banana",
                    value_path: "banana",
                    avatar: 'ba',
                    color : FindIcon.find('Banana').color,
                    img : FindIcon.find('Banana').img2,
                    stips_category : 1,
                    ads_category: 'Voće',
                    stips_source : 1,
                    catgeory_path: 'voce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    catgeory: 'voće',
                    title_search : 'banane',
                    title_search_re : 'banane',


                },
                
                {
                    id: 46,
                    description_page: `<p>Cena ananasa na pijaci zavisi od rodne godine zemlje odakle se uvozi, ponude i potražnje ananasa na tržištu i berzama. Prodaja ananasa je na malo po kilogramu težine.</br></br></p>

                    <p>Cena ananasa varira od pijace do pijace, kraja u Srbiji (cena ananasa u Vojvodini se razlikuje od cene ananasa u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p>U Srbiji se ananas uvozi za ljudsku upotrebu, sveži ananas kao voće se jede ili u većini slučajeva konzumira se kao sok od ananasa.  Takođe ananas se koristi i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                    `,
                    description_meta : `Cena ananasa na pijaci u Srbiji, cena ananasa kilogram, cena ananasa danas po gradovima i krajevima u Srbiji.`,
                   food : false,
                    alt: descriptionAltMarket('ananasa'),
                    title_path : descriptionMarket.srPath('juznog voca'),
                    description : descriptionMarket.srPath('ananasa'),
                    description_path : descriptionMarket.srPath('ananasa'),
                    value: "ananas",
                    value_path: "ananas",
                    avatar: 'an',
                    color : FindIcon.find('Ananas').color,
                    img : FindIcon.find('Ananas').img2,
                    stips_category : 1,
                    ads_category: 'Voće',
                    stips_source : 1,
                    catgeory_path: 'voce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    catgeory: 'voće',
                    title_search : 'ananasa',
                    title_search_re : 'ananasa',


                },
                {
                    id: 47,
                    description_page: `<p>Cena pomorandže, narandže na pijaci zavisi od rodne godine zemlje odakle se uvozi, ponude i potražnje pomorandže, narandže na tržištu i berzama. Prodaja pomorandže, narandže je na malo po kilogramu težine.</br></br></p>

                    <p>Cena pomorandže, narandže varira od pijace do pijace, kraja u Srbiji (cena pomorandže, narandže u Vojvodini se razlikuje od cene pomorandže, narandže u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p>U Srbiji se pomorandže, narandže uvoze za ljudsku upotrebu, sveža pomorandže, narandže kao voće se jede ili u većini slučajeva konzumira se kao sok od pomorandže, narandže.  Takođe pomorandže, narandže se koristi i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                    `,
                    description_meta : `Cena pomorandže, narandže na pijaci, cena pomorandže, narandže kilogram, cena pomorandže, narandže danas po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('pomorandže'),
                    title_path : descriptionMarket.srPath('juznog voca'),
                    description : descriptionMarket.srPath('pomorandže'),
                    description_path : descriptionMarket.srPath('pomorandze'),
                    value: "pomorandža",
                    value_path: "pomorandza",
                    avatar: 'po',
                    color : FindIcon.find('Pomorandža').color,
                    img : FindIcon.find('Pomorandža').img2,
                    stips_category : 1,
                    ads_category: 'Voće',
                    stips_source : 1,
                    catgeory: 'voće',
                    catgeory_path: 'voce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    title_search : 'pomorandze',
                    title_search_re : 'pomorandže',


                },
                {  
                    id: 48,
                    description_page: `<p>Cena jaja na pijaci zavisi od ponude i potražnje jaja na tržištu i berzama. Prodaja jaja je po veličini jajeta i komadu.</br></br></p>

                    <p>Cena jaja varira od pijace do pijace, kraja u Srbiji (cena jaja u Vojvodini se razlikuje od cene jaja u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p>U Srbiji se jaja koriste za ljudsku upotrebu, pečena, kuvana, prilog jelima, pite, peciva. Takođe jaja se koriste i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                    `,
                   description_meta : `Cena jaja na pijaci, cena jaja komad, cena jaja danas po gradovima i krajevima u Srbiji.`,
                   food : false,
                   alt: descriptionAltMarket('jaja (L)'),
                    description : descriptionMarket.srPath('jaja (L)'),
                    title_path : descriptionMarket.srPath('jaja i mleka'),
                    description_path : descriptionMarket.srPath('jaja (L)'),
                    value: "jaja (L)",
                    value_path: "jaja (L)",
                    avatar: 'L',
                    img: FindIcon.find('Jaja').img2,
                    color : FindIcon.find('Jaja').color,
                    stips_category : 12,
                    ads_category: 'Živina',
                    stips_source : 1,
                    catgeory_path: 'jaja',
                    text_other: '',
                    catgeory: 'jaja',
                    title_search : 'jaja (l)',
                    title_search_re : 'jaja (l)',


                    
                },
                {  
                    id: 49,
                    description_page: `<p>Cena mleka na pijaci zavisi od ponude i potražnje mleka na tržištu i berzama. Mleko se isključivo prodaje kao kravlje mleko, ali u ponudama postoje i kozje mleko i ovčje mleko. Prodaja mleka je po litri. Na pijacama postoje posebni frižideri i tezge gde se mleko čuva i prodaje.</br></br></p>

                    <p>Cena mleka varira od pijace do pijace, kraja u Srbiji (cena mleka u Vojvodini se razlikuje od cene mleka u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p> U Srbiji se mleko koristi za ljudsku upotrebu, kuvano mleko, prilog jelima, pite, peciva.  Takođe mleko se koristi i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                    `,
                    description_meta : `Cena mleka na pijaci, cena mleka litar, cena mleka danas po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('mleka'),
                    description : descriptionMarket.srPath('mleka'),
                    title_path : descriptionMarket.srPath('jaja i mleka'),
                    description_path : descriptionMarket.srPath('mleka'),
                    value: "mleko",
                    value_path: "mleko",
                    avatar: 'km',
                    img: FindIcon.find('Mleko').img2,
                    color : FindIcon.find('Mleko').color,
                    stips_category : 10,
                    ads_category: 'Stoka',
                    stips_source : 10,
                    catgeory: 'mleko',
                    catgeory_path: 'mleko',
                    text_other: '',
                    title_search : 'mleka',
                    title_search_re : 'mleka',
                    
                },
                
                {
                    id: 50,
                    description_page: `<p>Cena jaja na pijaci zavisi od ponude i potražnje jaja na tržištu i berzama. Prodaja jaja je po veličini jajeta i komadu.</br></br></p>

                    <p>Cena jaja varira od pijace do pijace, kraja u Srbiji (cena jaja u Vojvodini se razlikuje od cene jaja u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p> U Srbiji se jaja koriste za ljudsku upotrebu, pečena, kuvana, prilog jelima, pite, peciva. Takođe jaja se koriste i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                    `,
                    description_meta : `Cena jaja na pijaci, cena jaja komad, cena jaja danas po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('jaja (S)'),
                    description : descriptionMarket.srPath('jaja (S)'),
                    title_path : descriptionMarket.srPath('jaja i mleka'),
                    description_path : descriptionMarket.srPath('jaja (S)'),
                    value: "jaja (S)",
                    value_path: "jaja (S)",
                    avatar: 'S',
                    img: FindIcon.find('Jaja').img2,
                    color : FindIcon.find('Jaja').color,
                    stips_category : 12,
                    ads_category: 'Živina',
                    stips_source : 1,
                    catgeory: 'jaja',
                    catgeory_path: 'jaja',
                    text_other: '',
                    title_search : 'jaja (s)',
                    title_search_re : 'jaja (s)',
                },
                {
                    id: 51,
                    description_page: `<p>Cena piletine na pijaci zavisi od ponude i potražnje piletine na tržištu i berzama. Prodaja piletine je po koliogramu očišćenog tovnog pileta. Na pijacama postoje posebni frižideri i tezge gde se piletina čuva i prodaje.</br></br></p>

                    <p>Cena piletine varira od pijace do pijace, kraja u Srbiji (cena piletine u Vojvodini se razlikuje od cene piletine u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p> U Srbiji se piletina koristi za ljudsku upotrebu, pečeno pile, pileća kuvana supa, prilog jelima.</br></br></p>
                    `,
                    description_meta : `Cena piletine na pijaci, cena piletine kilogram, cena piletine danas po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('piletine'),
                    description : descriptionMarket.srPath('piletine'),
                    title_path : descriptionMarket.srPath('jaja i mleka'),
                    description_path : descriptionMarket.srPath('piletine'),
                    value: "piletina",
                    value_path: "piletina",
                    avatar: 'S',
                    img: FindIcon.find('Piletina').img2,
                    color : FindIcon.find('Piletina').color,
                    stips_category : 12,
                    ads_category: 'Živina',
                    stips_source : 1,
                    catgeory: 'piletine',
                    catgeory_path: 'piletina',
                    title_search : 'piletine',
                    title_search_re : 'piletina',
                },
                {
                    id: 52,
                    description_page: `<p>Cena jaja na pijaci zavisi od ponude i potražnje jaja na tržištu i berzama. Prodaja jaja je po veličini jajeta i komadu.</br></br></p>

                    <p> Cena jaja varira od pijace do pijace, kraja u Srbiji (cena jaja u Vojvodini se razlikuje od cene jaja u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p> U Srbiji se jaja koriste za ljudsku upotrebu, pečena, kuvana, prilog jelima, pite, peciva. Takođe jaja se koriste i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                    `,
                    description_meta : `Cena jaja na pijaci, cena jaja komad, cena jaja danas po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('jaja (XL)'),
                    description : descriptionMarket.srPath('jaja (XL)'),
                    title_path : descriptionMarket.srPath('jaja i mleka'),
                    description_path : descriptionMarket.srPath('jaja (XL)'),
                    value: "jaja (XL)",
                    value_path: "jaja (XL)",
                    avatar: 'XL',
                    img: FindIcon.find('Jaja').img2,
                    color : FindIcon.find('Jaja').color,
                    stips_category : 12,
                    ads_category: 'Živina',
                    stips_source : 1,
                    catgeory: 'jaja',
                    catgeory_path: 'jaja',
                    text_other: '',
                    title_search : 'jaja (xl)',
                    title_search_re : 'jaja (xl)',
                    
                },
                {
                    id: 53,
                    description_page: `<p>Cena kajmaka na pijaci zavisi od ponude i potražnje mleka na tržištu i berzama. Prodaja kajmaka je po kilogramu. Na pijacama postoje posebni frižideri i tezge gde se kajmak čuva i prodaje.</br></br></p>

                    <p> Cena kajmaka varira od pijace do pijace, cene mleka, kraja u Srbiji (cena mleka u Vojvodini se razlikuje od cene mleka u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p> U Srbiji se kajmak koristi za ljudsku upotrebu, prilog jelima, pite, peciva.</br></br></p>
                    `,
                    description_meta : `Cena kajmaka na pijaci, cena kajmaka kilogram, cena kajmaka danas po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('kajmaka'),
                    description : descriptionMarket.srPath('kajmaka'),
                    title_path : descriptionMarket.srPath('jaja i mleka'),
                    description_path : descriptionMarket.srPath('kajmaka'),
                    value: "kajmak",
                    value_path: "kajmak",
                    avatar: 'km',
                    img: FindIcon.find('Kajmak').img2,
                    color : FindIcon.find('Kajmak').color,
                    stips_category : 11,
                    ads_category: 'Stoka',
                    stips_source : 1,
                    catgeory: 'kajmak',
                    catgeory_path: 'kajmak',
                    title_search : 'kajmaka',
                    title_search_re : 'kajmaka',
                    
                },
                {
                    id: 54,
                    description_page: `<p>Cena belog sira na pijaci zavisi od ponude i potražnje mleka na tržištu i berzama. Prodaja belog sira je po koliogramu. Na pijacama postoje posebni frižideri i tezge gde se beli sir čuva i prodaje.</br></br></p>

                    <p>Cena belog sir varira od pijace do pijace, cene mleka, kraja u Srbiji (cena mleka u Vojvodini se razlikuje od cene mleka u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p> U Srbiji se beli sir koristi za ljudsku upotrebu, prilog jelima, pite, peciva.</br></br></p>
                    `,
                    description_meta : `Cena belog sira na pijaci, cena belog sira kilogram, cena belog sira danas po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('belog sira (masni)'),
                    description : descriptionMarket.srPath('belog sira (masni)'),
                    title_path : descriptionMarket.srPath('jaja i mleka'),
                    description_path : descriptionMarket.srPath('belog sira (masni)'),
                    value: "beli sir (masni)",
                    value_path: "beli sir (masni)",
                    avatar: 'bs',
                    img: FindIcon.find('Beli sir').img2,
                    color : FindIcon.find('Beli sir').color,
                    stips_category : 11,
                    ads_category: 'Stoka',
                    stips_source : 1,
                    catgeory_path: 'sir',
                    catgeory: 'sir',
                    title_search : 'belog sira (masni)',
                    title_search_re : 'belog sira (masni)',
                    
                },
                {
                    id: 55,
                    description_page: `<p>Cena belog sira na pijaci zavisi od ponude i potražnje mleka na tržištu i berzama. Prodaja belog sira je po koliogramu. Na pijacama postoje posebni frižideri i tezge gde se beli sir čuva i prodaje.</br></br></p>

                    <p>Cena belog sir varira od pijace do pijace, cene mleka, kraja u Srbiji (cena mleka u Vojvodini se razlikuje od cene mleka u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p> U Srbiji se beli sir koristi za ljudsku upotrebu, prilog jelima, pite, peciva.</br></br></p>
                    `,
                    description_meta : `Cena belog sira na pijaci, cena belog sira kilogram, cena belog sira danas po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('belog sira (polumasni)'),
                    description : descriptionMarket.srPath('belog sira (polumasni)'),
                    title_path : descriptionMarket.srPath('jaja i mleka'),
                    description_path : descriptionMarket.srPath('belog sira (polumasni)'),
                    value: "beli sir (polumasni)",
                    value_path: "beli sir (polumasni)",
                    avatar: 'bs',
                    img: FindIcon.find('Beli sir').img2,
                    color : FindIcon.find('Beli sir').color,
                    stips_category : 11,
                    ads_category: 'Stoka',
                    stips_source : 1,
                    catgeory: 'sir',
                    catgeory_path: 'sir',
                    title_search : 'belog sira (polumasni)',
                    title_search_re : 'belog sira (polumasni)',
                    
                },
                {
                    id: 56,
                    description_page: `<p>Cena jaja na pijaci zavisi od ponude i potražnje jaja na tržištu i berzama. Prodaja jaja je po veličini jajeta i komadu.</br></br></p>

                    <p> Cena jaja varira od pijace do pijace, kraja u Srbiji (cena jaja u Vojvodini se razlikuje od cene jaja u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>
                    
                    <p> U Srbiji se jaja koriste za ljudsku upotrebu, pečena, kuvana, prilog jelima, pite, peciva. Takođe jaja se koriste i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>
                    `,
                    description_meta : `Cena jaja na pijaci, cena jaja komad, cena jaja danas po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('jaja (M)'),
                    description : descriptionMarket.srPath('jaja (M)'),
                    title_path : descriptionMarket.srPath('jaja i mleka'),
                    description_path : descriptionMarket.srPath('jaja (M)'),
                    value: "jaja (M)",
                    value_path: "jaja (M)",
                    avatar: 'M',
                    img: FindIcon.find('Jaja').img2,
                    color : FindIcon.find('Jaja').color,
                    stips_category : 12,
                    ads_category: 'Živina',
                    stips_source : 1,
                    catgeory: 'jaja',
                    catgeory_path: 'jaja',
                    text_other: '',
                    title_search : 'jaja (m)',
                    title_search_re : 'jaja (m)',
                    
                },
                {
                    id: 57,
                    description_page: `<p>Cena šargarepe na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje šargarepe na svetskoj berzi, da li je cena na veliko. </br></br></p>

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena šargarepe u zapadnoj Srbiji se razlikuje od cene šargarepe u istočnoj ili centralnoj Srbiji ili Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                    
                    <p>  U Srbiji se šargarepa sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Šargarepa se naziva i mrkva. Šargarepa se koristi i jede sveža, barena, sitno seckana suva za začine, ukiseljena šargarepa. Šargarepa se prodaje i otkupljuje uglavnom po kilogramu težine ili po komadu na malo.</br></br></p>
                    `,
                    description_meta : `Cena šargarepe na pijaci, otkupna cena šargarepe, ponude i potražnje šargarepe na svetskoj berzi, trenutna cena šargarepe po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('šargarepe'),
                    description : descriptionMarket.srPath('šargarepe'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('sargarepe'),
                    value: "šargarepa",
                    value_path: "sargarepa",
                    avatar: 'ša',
                    color : FindIcon.find('Šargarepa').color,
                    img : FindIcon.find('Šargarepa').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'sargarepe',
                    title_search_re : 'šargarepe',
                },
               
                {
                    id: 58,
                    description_page: `<p>Cena cvekle na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje cvekle na svetskoj berzi, da li je cena na veliko, koja je sorta cvekle.  </br></br></p>

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena cvekle u zapadnoj Srbiji se razlikuje od cene cvekle u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine. </br></br></p>
                    
                    <p> U Srbiji se cvekla sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Cvekla se kiseli, termički obađuje, ali se jede i sveža kao salata. Cvekla može biti u konzervi, a može biti i sok od cvekle ili cvekla u prahu. Cvekla se prodaje i otkupljuje uglavnom po kilogramu težine. </br></br></p>
                    `,
                    description_meta : `Cena cvekle na pijaci, otkupna cena cvekle, ponude i potražnje cvekle na svetskoj berzi, trenutna cena cvekle po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('cvekle'),
                    description : descriptionMarket.srPath('cvekle') ,
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('cvekle') ,
                    value: "cvekla",
                    value_path: "cvekla",
                    avatar: 'cv',
                    color : FindIcon.find('Cvekla').color,
                    img : FindIcon.find('Cvekla').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'cvekle',
                    title_search_re : 'cvekle',
                },
                {
                    id: 59,
                    description_page: `<p>Cena krompira na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje krompira na svetskoj berzi, da li je cena na veliko, koja je sorta krompira, da li je mladi krompir, beli ili crveni krompir. </br></br></p>

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena krompira u istočnoj ili zapadnoj Srbiji se razlikuje od cene krompira u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                    
                    <p> U Srbiji se krompir sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu, i ishranu životinja. Krompir se jede uglavnom pečen ili skuvan. Naziv krompir se odnosi na krtolu krompira. Najpoznatiji su beli i crveni kromir. Krompir se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p>
                    `,
                    description_meta : `Cena krompira na pijaci, cena mladog krompira, ponude i potražnje krompira na svetskoj berzi, trenutna cena krompira po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('krompira'),
                    description : descriptionMarket.srPath('krompira'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('krompira'),
                    value: "krompir",
                    value_path: "krompir",
                    avatar: 'kr',
                    color : FindIcon.find('Krompir').color,
                    img : FindIcon.find('Krompir').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'krompira',
                    title_search_re : 'krompira',
                },
                {
                    id: 60,
                    description_page: `<p>Cena kupusa na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje kupusa na svetskoj berzi, da li je cena na veliko, cena kupusa na kvantaškoj pijaci, koja je sorta kupusa. </br></br></p>

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena kupusa u zapadnoj Srbiji se razlikuje od cene kupusa u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                    
                    <p> U Srbiji se kupus sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Kupus se kiseli, termički obađuje, ali se jede i svež kao salata. Kupus može biti kiseo u glavicama ili izrendan. Najčešće se jede beli kupus i crveni kupus. Kupus se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p>
                    `,
                    description_meta : `Cena kupusa na pijaci, otkupna cena kupusa, ponude i potražnje kupusa na svetskoj berzi, trenutna cena kupusa po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('kupusa'),
                    description : descriptionMarket.srPath('kupusa') ,
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('kupusa') ,
                    value: "kupus",
                    value_path: "kupus",
                    avatar: 'ku',
                    color : FindIcon.find('Kupus').color,
                    img : FindIcon.find('Kupus').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'kupusa',
                    title_search_re : 'kupusa',
                },
                {
                    id: 61,
                    description_page: `<p>Cena pečuraka, šampinjona na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje pečuraka, šampinjona na svetskoj berzi, da li je cena na veliko. </br></br></p> 

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena pečuraka, šampinjona u zapadnoj Srbiji se razlikuje od cene pečuraka, šampinjona u istočnoj ili centralnoj Srbiji ili Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p> U Srbiji se pečurke, šampinjoni sade i gaje i obrađuju za ishranu domaćinstava i industrijsku proizvodnju i obradu. Pečurke se uglavnom koriste u raznim jelima, ali jedu se i sveže pečene ili obarene. Pečurke, šampinjoni se prodaju i otkupljuju uglavnom po kilogramu.</br></br></p> 
                    `,
                    description_meta : `Cena pečuraka, šampinjona na pijaci, otkupna cena pečuraka, šampinjona, ponude i potražnje pečuraka, šampinjona na svetskoj berzi, trenutna cena pečuraka, šampinjona po gradovima i krajevima u Srbiji.`,
                   food : false,
                    alt: descriptionAltMarket('pečuraka'),
                    description :  descriptionMarket.srPath('pečuraka'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path :  descriptionMarket.srPath('pecuraka'),
                    value: "pečurke",
                    value_path: "pecurke",
                    avatar: 'pe',
                    color : FindIcon.find('Pečurke').color,
                    img : FindIcon.find('Pečurke').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'pecuraka',
                    title_search_re : 'pečuraka',
                },
                {
                    id: 62,
                    description_page: `<p>Cena celera na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje celera na svetskoj berzi, da li je cena na veliko, koja je sorta celera. </br></br></p>

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena celera u zapadnoj Srbiji se razlikuje od cene celera u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                    
                    <p> U Srbiji se celer sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. List celera i koren celera se obrađuju za jelo. Sok od celera i sveži celer su najčešće u ubotrebi kod domaćinstava. Celer se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p>
                    `,
                    description_meta : `Cena celera na pijaci, otkupna cena celera, ponude i potražnje celera na svetskoj berzi, trenutna cena celera po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('celera'),
                    description : descriptionMarket.srPath('celera'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('celera'),
                    value: "celer",
                    value_path: "celer",
                    avatar: 'ce',
                    color : FindIcon.find('Celer').color,
                    img : FindIcon.find('Celer').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'celera',
                    title_search_re : 'celera',
                },
                {
                    id: 63,
                    description_page: `<p>Cena blitve na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje blitve na svetskoj berzi, da li je cena na veliko, koja je sorta blitve. </br></br></p>

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena blitve u zapadnoj Srbiji se razlikuje od cene blitve u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                    
                    <p> U Srbiji se blitva sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu, i ishranu životinja. List blitve se obrađuju za jelo i ljudsku ishranu. Blitva se prodaje i otkupljuje uglavnom po kilogramu težine ili po vezi određenog broja listova blitve.</br></br></p>
                    `,
                    description_meta : `Cena blitve na pijaci, cena veze blitve, ponude i potražnje blitve na svetskoj berzi, trenutna cena blitve po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('blitve'),
                    description :  descriptionMarket.srPath('blitve'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path :  descriptionMarket.srPath('blitve'),
                    value: "blitva",
                    value_path: "blitva",
                    avatar: 'bl',
                    color : FindIcon.find('Blitva').color,
                    img : FindIcon.find('Blitva').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'blitve',
                    title_search_re : 'blitve',
                },
                {
                    id: 64,
                    description_page: `<p>Cena dinja na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje dinja na svetskoj berzi, da li je cena na veliko, koja je sorta dinja. </br></br></p>

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena dinje u zapadnoj Srbiji se razlikuje od cene dinje u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                    
                    <p> U Srbiji se dinja sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu, i ishranu životinja. Plod dinje je okruglog oblika, težine oko 1 do 2 kilograma, žute ili narandžaste boje. Dinja se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p>
                    `,
                    description_meta : `Cena dinja na pijaci, otkupna cena dinja, ponude i potražnje dinja na svetskoj berzi, trenutna cena dinja po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('dinje'),
                    description : descriptionMarket.srPath('dinje') ,
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('dinje') ,
                    value: "dinja",
                    value_path: "dinja",
                    avatar: 'dn',
                    color : FindIcon.find('Dinja').color,
                    img : FindIcon.find('Dinja').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'dinje',
                    title_search_re : 'dinje',
                },
                {
                    id: 65,
                    description_page: `<p>Cena karfiola na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje karfiola na svetskoj berzi, da li je cena na veliko, koja je sorta karfiola. </br></br></p>

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena karfiola u zapadnoj Srbiji se razlikuje od cene karfiola u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                    
                    <p>  U Srbiji se karfiol sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu, i ishranu životinja. Karfiol je sorta kupusa. Glava, ruža, cvast, zbijeni deo karfiola bele boje koristi se u ishrani. Jede se svež, kuvan ili kiseo karfiol. Karfiol se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p>
                    `,
                    description_meta : `Cena karfiola na pijaci, otkupna cena karfiola, ponude i potražnje karfiola na svetskoj berzi, trenutna cena karfiola po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('karfiola'),
                    description : descriptionMarket.srPath('karfiola') ,
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('karfiola') ,
                    value: "karfiol",
                    value_path: "karfiol",
                    avatar: 'kf',
                    color : FindIcon.find('Karfiol').color,
                    img : FindIcon.find('Karfiol').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'karfiola',
                    title_search_re : 'karfiola',
                },
                {
                    id: 66,
                    description_page: `<p>Cena kelja na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje kelja na svetskoj berzi, da li je cena na veliko, koja je sorta kelja. </br></br></p>

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena kelja u zapadnoj Srbiji se razlikuje od cene kelja u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                    
                    <p> U Srbiji se kelj sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu, i ishranu životinja. Kelj je sorta kupusa. Ukrasni kelj, lisnati kelj, kelj pupčar su glavne sorte za prodaju. Kelj se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p>
                    `,
                    description_meta : `Cena kelja na pijaci, cena kelj pupčar, ponude i potražnje kelja na svetskoj berzi, trenutna cena kelja po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('kelja'),
                    description : descriptionMarket.srPath('kelja') ,
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('kelja') ,
                    value: "kelj",
                    value_path: "kelj",
                    avatar: 'ke',
                    img : FindIcon.find('Kelj').img2,
                    color : FindIcon.find('Kelj').color,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'kelja',
                    title_search_re : 'kelja',
                },
                {
                    id: 67,
                    description_page: `<p>Cena krastavaca na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje krastavaca na svetskoj berzi, da li je cena na veliko, koja je sorta krastavaca. </br></br></p>

                    <p>  Cena varira od pijace do pijace, kraja u Srbiji (cena krastavaca u zapadnoj Srbiji se razlikuje od cene krastavaca u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                    
                    <p>U Srbiji se krastavac sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu, i ishranu životinja. Krastavac se jede uglavnom svež i kiseo. Krastavac je zeljasta biljka iz porodice bundeva. Najpoznatije sorte su kornišon i salatar. Krastavci se prodaju i otkupljuju uglavnom po kilogramu težine.</br></br></p>
                    `,
                    description_meta : `Cena krastavaca na pijaci, cena krastavac kornišon, ponude i potražnje krastavca na svetskoj berzi, trenutna cena kelja po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('krastavaca'),
                    description : descriptionMarket.srPath('krastavaca'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('krastavaca'),
                    value: "krastavac",
                    value_path: "krastavac",
                    avatar: 'kr',
                    color : FindIcon.find('Krastavac').color,
                    img : FindIcon.find('Krastavac').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'krastavaca',
                    title_search_re : 'krastavaca',
                },
                {
                    id: 68,
                    description_page: `<p>Cena boranije na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje boranije na svetskoj berzi, da li je cena na veliko, koja je sorta boranije. </br></br></p>

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena boranije u zapadnoj Srbiji se razlikuje od cene boranije u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine. </br></br></p>
                    
                    <p>  U Srbiji se boranija sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Da li je sveža boranija, zelena, žuta, šarena. Plod boranije naziva se mahuna. Po obliku može biti valjkasta, sabljasta, srpasta. Boranija se prodaje i otkupljuje uglavnom po kilogramu težine. </br></br></p>
                    `,
                    description_meta : `Cena boranije na pijaci, otkupna cena boranije, cena mahuna, ponude i potražnje boranije na svetskoj berzi, trenutna cena boranije po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('boranije'),
                    description : descriptionMarket.srPath('boranije') ,
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('boranije') ,
                    value: "boranija",
                    value_path: "boranija",
                    avatar: 'bo',
                    color : FindIcon.find('Boranija').color,
                    img : FindIcon.find('Boranija').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'boranije',
                    title_search_re : 'boranije',

                },
                {
                    id: 69,
                    description_page: `<p>Cena lubenica na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje lubenica na svetskoj berzi, da li je cena na veliko, koja je sorta lubenica. </br></br></p>

                    <p>  Cena varira od pijace do pijace, kraja u Srbiji (cena lubenica u zapadnoj Srbiji se razlikuje od cene lubenica u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                    
                    <p> U Srbiji se lubenica sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu, i ishranu životinja. Lubenica je zeljasta biljka iz porodice bundeva. Lubenica se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p>
                    `,
                    description_meta : `Cena lubenica na pijaci, otkupna cena lubenica, ponude i potražnje lubenica na svetskoj berzi, trenutna cena lubenica po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('lubenice'),
                    description :  descriptionMarket.srPath('lubenice'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path :  descriptionMarket.srPath('lubenice'),
                    value: "lubenica",
                    value_path: "lubenica",
                    avatar: 'lb',
                    color : FindIcon.find('Lubenica').color,
                    img : FindIcon.find('Lubenica').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'lubenice',
                    title_search_re : 'lubenice',
                },
                {
                    id: 70,
                    description_page: `<p>Cena belog luka na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje belog luka na svetskoj berzi, da li je cena na veliko, koja je sorta belog luka, da li je beli luk za seme.</br></br></p> 

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena belog luka u zapadnoj Srbiji se razlikuje od cene belog luka u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                    
                    <p> U Srbiji se beli luk sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu, naročito u farmaceutskoj industriji. Po narodnom verovanju beli luk je lek za sve i prirodni antibiotik. Beli luk se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p>
                    `,
                    description_meta : `Cena belog luka na pijaci, otkupna cena beli luk, ponude i potražnje belog luka na svetskoj berzi, trenutna cena belog luka po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('belog luka'),
                    description :  descriptionMarket.srPath('belog luka'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path :  descriptionMarket.srPath('belog luka'),
                    value: "luk beli",
                    value_path: "luk beli",
                    avatar: 'bl',
                    color : FindIcon.find('Luk').color,
                    img : FindIcon.find('Luk').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'belog luka',
                    title_search_re : 'belog luka',
                },
                {
                    id: 71,
                    description_page: `<p>Cena crnog luka na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje crnog luka na svetskoj berzi, da li je cena na veliko, koja je sorta crnog luka, da li je crni luk za seme ili je mladi luk. </br></br></p> 

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena crnog luka u zapadnoj Srbiji se razlikuje od cene crnog luka u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p>  U Srbiji se crni luk sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu, naročito u farmaceutskoj industriji. Po narodnom verovanju crni luk je lek za dosta bolesti, kašalj, sinusi, srce, disanje. Crni luk se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p> 
                    `,
                    description_meta : `Cena crnog luka na pijaci, otkupna cena crni luk, ponude i potražnje crnog luka na svetskoj berzi, trenutna cena crnog luka po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('crnog luka'),
                    description : descriptionMarket.srPath('crnog luka'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('crnog luka'),
                    value: "luk crni",
                    value_path: "luk crni",
                    avatar: 'cl',
                    color : FindIcon.find('Luk').color,
                    img : FindIcon.find('Luk').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'crnog luka',
                    title_search_re : 'crnog luka',
                },
                {
                    id: 72,
                    description_page: `<p>Cena paprike na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje paprike na svetskoj berzi, da li je cena na veliko, koja je sorta paprike, da li je paprika za kiselu salatu, pečenje, mlevenje, sušenje. </br></br></p> 

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena paprika u zapadnoj Srbiji se razlikuje od cene paprika u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p>  U Srbiji se paprika sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Paprika se koristi i za lek i začin. Najpoznatije su paprika babura, paprika šilja, ljuta paprika. Paprika se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p> 
                    `,
                    description_meta : `Cena paprike na pijaci, otkupna cena paprika, ponude i potražnje paprike na svetskoj berzi, trenutna cena paprike po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('paprike'),
                    description : descriptionMarket.srPath('paprike') ,
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('paprike') ,
                    value: "paprika",
                    value_path: "paprika",
                    avatar: 'pa',
                    color : FindIcon.find('Paprika').color,
                    img : FindIcon.find('Paprika').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'paprike',
                    title_search_re : 'paprike',
                },
                {
                    id: 73,
                    description_page: `<p>Cena paradajza na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje paradajza na svetskoj berzi, da li je cena na veliko, koja je sorta paradajza, da li je zeleni paradajz za kiselu salatu, da li je paradajz za sos ili kečap, sok od pradajza.</br></br></p> 

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena paradajza u zapadnoj Srbiji se razlikuje od cene paradajza u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p> U Srbiji se paradajz sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Paradajz se koristi i za lek, začin, ali se u ishrani dosta jede svež. Paradajz se naziva i rajčica. Šeri paradajz, zeleni paradajz su samo neke od vrsta kako se prodaju. Paradajz se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p> 
                    `,
                    description_meta : `Cena paradajza na pijaci, otkupna cena paradajza, ponude i potražnje paradajza na svetskoj berzi, trenutna cena paradajza po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('paradajza'),
                    description :  descriptionMarket.srPath('paradajza'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path :  descriptionMarket.srPath('paradajza'),
                    value: "paradajz",
                    value_path: "paradajz",
                    avatar: 'pa',
                    color : FindIcon.find('Paradajz').color,
                    img : FindIcon.find('Paradajz').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'paradajza',
                    title_search_re : 'paradajza',
                },
                {
                    id: 74,
                    description_page: `<p>Cena pasulja na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje pasulja na svetskoj berzi, da li je cena na veliko, koja je sorta pasulja. </br></br></p> 

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena pasulja u zapadnoj Srbiji se razlikuje od cene pasulja u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p> U Srbiji se pasulj sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Pasulj ili grah je iz porodice mahunarki. Najpoznatije sorte za prodaju su beli gradištanac, beli tetovac, beli pasulj, šareni pasulj, žuti pasulj. Pasulj se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p> 
                    `,
                    description_meta : `Cena pasulja na pijaci, otkupna cena pasulja, ponude i potražnje pasulja na svetskoj berzi, trenutna cena pasulja po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('pasulja'),
                    description : descriptionMarket.srPath('pasulja') ,
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('pasulja') ,
                    value: "pasulj",
                    value_path: "pasulj",
                    avatar: 'pa',
                    color : FindIcon.find('Pasulj').color,
                    img : FindIcon.find('Pasulj').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'pasulja',
                    title_search_re : 'pasulja',
                },
                {
                    id: 75,
                    description_page: `<p>Cena patlidžana na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje patlidžana na svetskoj berzi, da li je cena na veliko. </br></br></p> 

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena patlidžana u zapadnoj Srbiji se razlikuje od cene patlidžana u istočnoj ili centralnoj Srbiji ili Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p> U Srbiji se patlidžan sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Patlidžan se naziva plavi paradajz ili plavi patlidžan. Plod patlidžana je bobica, najčešće je ljubičasto plave boje, ali može biti i zelene, žute ili bele boje. Patlidžan se prodaje i otkupljuje uglavnom po kilogramu težine ili po komadu za mali broj prodaje ili kupovine.</br></br></p> 
                    `,
                    description_meta : `Cena patlidžana na pijaci, otkupna cena patlidžana, ponude i potražnje patlidžana na svetskoj berzi, trenutna cena patlidžana po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('patlidžana'),
                    description :  descriptionMarket.srPath('patlidžana'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path :  descriptionMarket.srPath('patlidzana'),
                    value: "patlidžan",
                    value_path: "patlidzan",
                    avatar: 'pa',
                    color : FindIcon.find('Patlidžan').color,
                    img : FindIcon.find('Patlidžan').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'patlidzana',
                    title_search_re : 'patlidžana',
                },
                {
                    id: 76,
                    description_page: `<p>Cena paškanata na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje paškanata na svetskoj berzi, da li je cena na veliko, koja je sorta paškanata. 

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena paškanata u zapadnoj Srbiji se razlikuje od cene paškanata u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p> U Srbiji se paškanat sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. List paškanata i koren paškanata se obrađuju za jelo ili se koriste sveži. Uglavnom paškanat je zastupljen u supama, kuvanim jelima, salatam. paškanat se prodaje i otkupljuje uglavnom po kilogramu težine ili po komadu na malo.</br></br></p> 
                    `,
                    description_meta : `Cena paškanata na pijaci, otkupna cena paškanata, ponude i potražnje paškanata na svetskoj berzi, trenutna cena paškanata po gradovima i krajevima u Srbiji. `,
                    food : false,
                    alt: descriptionAltMarket('paškanata'),
                    description : descriptionMarket.srPath('paškanata'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('paskanata'),
                    value: "paškanat",
                    value_path: "paskanat",
                    avatar: 'pa',
                    color : FindIcon.find('Paškanat').color,
                    img : FindIcon.find('Paškanat').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'paskanata',
                    title_search_re : 'paškanata',
                },
                
                {
                    id: 77,
                    description_page: `<p>Cena peršuna na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje peršuna na svetskoj berzi, da li je cena na veliko, da li je peršun lišćar ili peršun korenaš.</br></br></p> 

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena peršuna u zapadnoj Srbiji se razlikuje od cene peršuna u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p>
                    
                    <p> U Srbiji se peršun sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. List peršuna i koren peršuna se obrađuju za jelo ili se koriste sveži. Peršunov list ne treba kuvati nego ga dodati na kraju jela. Peršun se prodaje i otkupljuje uglavnom po kilogramu težine ili po komadu na malo.</br></br></p>
                    `,
                    description_meta : `Cena peršuna na pijaci, cena peršun lišćar i korenaš, ponude i potražnje peršuna na svetskoj berzi, trenutna cena peršuna po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('peršuna'),
                    description : descriptionMarket.srPath('peršuna'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('persuna'),
                    value: "peršun",
                    value_path: "persun",
                    avatar: 'pš',
                    color : FindIcon.find('Peršun').color,
                    img : FindIcon.find('Peršun').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'persuna',
                    title_search_re : 'peršuna',
                },
               
                {
                    id: 78,
                    description_page: `<p>Cena praziluka na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje praziluka na svetskoj berzi, da li je cena na veliko, koja je sorta praziluka.  </br></br></p> 

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena praziluka u zapadnoj Srbiji se razlikuje od cene praziluka u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine. </br></br></p> 
                    
                    <p>  U Srbiji se praziluk sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Praziluk se jede svež ili kao začin i dodatak jelima. Praziluk se prodaje i otkupljuje uglavnom po kilogramu težine. </br></br></p> 
                    `,
                    description_meta : `Cena praziluka na pijaci, otkupna cena praziluka, ponude i potražnje praziluka na svetskoj berzi, trenutna cena praziluka po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('praziluka'),
                    description : descriptionMarket.srPath('praziluka'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('praziluka'),
                    value: "praziluk",
                    value_path: "praziluk",
                    avatar: 'pl',
                    color : FindIcon.find('Praziluk').color,
                    img : FindIcon.find('Praziluk').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'praziluka',
                    title_search_re : 'praziluka',
                },
                {
                    id: 79,
                    description_page: `<p>Cena rotkvica na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje rotkvica na svetskoj berzi, da li je cena na veliko, koja je sorta rotkvica. </br></br></p> 

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena rotkvica u zapadnoj Srbiji se razlikuje od cene rotkvica u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p>  U Srbiji se rotkvica sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu, i ishranu životinja. Rotkvica je sorta kupusa. Rotkvice, crne rotkvice, uljane rotkvice samo su neke od vrsta rotkvica. Rotkvica se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p> 
                    `,
                    description_meta : `Cena rotkvica na pijaci, otkupna cena rotkvica, ponude i potražnje rotkvica na svetskoj berzi, trenutna cena rotkvica po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('rotkvice'),
                    description : descriptionMarket.srPath('rotkvice') ,
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('rotkvice') ,
                    value: "rotkvica",
                    value_path: "rotkvica",
                    avatar: 'ro',
                    color : FindIcon.find('Rotkvica').color,
                    img : FindIcon.find('Rotkvica').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'rotkvice',
                    title_search_re : 'rotkvice',
                },
                {
                    id: 80,
                    description_page: `<p>Cena spanaća na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje spanaća na svetskoj berzi, da li je cena na veliko, cena spanaća na kvantaškoj pijaci, koja je sorta spanaća. </br></br></p> 

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena spanaća u zapadnoj Srbiji se razlikuje od cene spanaća u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p>U Srbiji se spanać sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Spanać se koristi kao sveži obareni prilog, potom kao salata, razne pite. Spanać se prodaje i otkupljuje uglavnom po kilogramu težine ili po komadu na malu prodaju ili kupovinu.</br></br></p> 
                    `,
                    description_meta : `Cena spanaća na pijaci, otkupna cena spanaća, ponude i potražnje spanaća na svetskoj berzi, trenutna cena spanaća po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('spanaća'),
                    description :  descriptionMarket.srPath('spanaća'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path :  descriptionMarket.srPath('spanaca'),
                    value: "spanać",
                    value_path: "spanac",
                    avatar: 'ro',
                    color : FindIcon.find('Spanać').color,
                    img : FindIcon.find('Spanać').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'spanaca',
                    title_search_re : 'spanaća',
                },
                {
                    id: 81,
                    description_page: `<p>Cena tikvica na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje tikvica na svetskoj berzi, da li je cena na veliko, koja je sorta tikvica. </br></br></p> 

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena tikvica u zapadnoj Srbiji se razlikuje od cene tikvica u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p> U Srbiji se tikvica sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu, i ishranu životinja. Tikvica je iz familije bundeva. Tikvica se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p> 
                    `,
                    description_meta : `Cena tikvica na pijaci, otkupna cena tikvica, ponude i potražnje tikvica na svetskoj berzi, trenutna cena tikvica po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('tikvica'),
                    description : descriptionMarket.srPath('tikvica') ,
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('tikvica') ,
                    value: "tikvice",
                    value_path: "tikvica",
                    avatar: 'ro',
                    color : FindIcon.find('Tikvica').color,
                    img : FindIcon.find('Tikvica').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'tikvica',
                    title_search_re : 'tikvica',
                },
                {
                    id: 82,
                    description_page: `<p>Cena zeleni na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje zeleni na svetskoj berzi, da li je cena na veliko, cena zeleni na kvantaškoj pijaci, koja je sorta zeleni. </br></br></p> 

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena zeleni u zapadnoj Srbiji se razlikuje od cene zeleni u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p> U Srbiji se zelen sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Upotreba je višestruka od priloga jelu kao salata, do raznih začina, pita. Zelen se prodaje i otkupljuje uglavnom po kilogramu težine ili po komadu na malu prodaju ili kupovinu.</br></br></p> 
                    `,
                    description_meta : `Cena zeleni na pijaci, ponude i potražnje zeleni na svetskoj berzi, trenutna cena zeleni po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('zeleni'),
                    description : descriptionMarket.srPath('zeleni'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('zeleni'),
                    value: "zelen",
                    value_path: "zelen",
                    avatar: 'ze',
                    color : FindIcon.find('Zelen').color,
                    img : FindIcon.find('Zelen').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'zeleni',
                    title_search_re : 'zeleni',
                },
                {
                    id: 83,
                    description_page: `<p>Cena zelene salate na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje zelene salate na svetskoj berzi, da li je cena na veliko, cena zelene salate na kvantaškoj pijaci, koja je sorta zelene salate. </br></br></p> 

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena zelene salate u zapadnoj Srbiji se razlikuje od cene zelene salate u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p>  U Srbiji se zelena salata sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Upotreba je višestruka od priloga jelu kao salata, do raznih začina, pita. Zelena salata se prodaje i otkupljuje uglavnom po kilogramu težine ili po komadu na malu prodaju ili kupovinu.</br></br></p> 
                    `,
                    description_meta : `Cena zelene salate na pijaci, ponude i potražnje zelene salate na svetskoj berzi, trenutna cena zelene salate po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('zelene salate'),
                    description :  descriptionMarket.srPath('zelene salate'), 
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path :  descriptionMarket.srPath('zelene salate'),
                    value: "zelena salata",
                    value_path: "zelena salata",
                    avatar: 'ze',
                    color : FindIcon.find('Zelena salata').color,
                    img : FindIcon.find('Zelena salata').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'zelene salate',
                    title_search_re : 'zelene salate',
                },
                {
                    id: 84,
                    description_page: `<p>Cena zelja na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje zelja na svetskoj berzi, da li je cena na veliko, cena zelja na kvantaškoj pijaci, koja je sorta zelja. </br></br></p> 

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena zelja u zapadnoj Srbiji se razlikuje od cene zelja u istočnoj ili centralnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p>  U Srbiji se zelje sadi i gaji i obrađuje za ishranu domaćinstava i industrijsku proizvodnju i obradu. Upotreba je višestruka od priloga jelu kao salata, do raznih začina, pita. Zelje se prodaje i otkupljuje uglavnom po kilogramu težine ili po komadu na malu prodaju ili kupovinu.</br></br></p> 
                    `,
                    description_meta : `Cena zelja na pijaci, ponude i potražnje zelja na svetskoj berzi, trenutna cena zelja po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('zelja'),
                    description : descriptionMarket.srPath('zelja') ,
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path : descriptionMarket.srPath('zelja') ,
                    value: "zelje",
                    value_path: "zelje",
                    avatar: 'ze',
                    color : FindIcon.find('Zelje').color,
                    img : FindIcon.find('Zelje').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'zelja',
                    title_search_re : 'zelja',
                },
                {
                    id: 85,
                    description_page: `<p>Cena rena na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje rena na svetskoj berzi, da li je cena na veliko, koja je sorta rena. </br></br></p> 

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena rena u zapadnoj Srbiji se razlikuje od cene rena u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p> U Srbiji se ren sadi i gaji i obrađuje za ishranu i industrijsku proizvodnju. Ren se koristi kao prilog jelima, veoma je lekovit. Ren se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p> 
                    `,
                    description_meta : `Cena rena na pijaci, otkupna cena rena, ponude i potražnje rena na svetskoj berzi, trenutna cena rena po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('rena'),
                    description :  descriptionMarket.srPath('rena'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path :  descriptionMarket.srPath('rena'),
                    value: "ren",
                    value_path: "ren",
                    avatar: 're',
                    color : FindIcon.find('Ren').color,
                    img : FindIcon.find('Ren').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'rena',
                    title_search_re : 'rena',
                },
                {
                    id: 86,
                    description_page: `<p>Cena rotkve na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje rotkve na svetskoj berzi, da li je cena na veliko, koja je sorta rotkve. </br></br></p> 

                    <p>Cena varira od pijace do pijace, kraja u Srbiji (cena rotkve u zapadnoj Srbiji se razlikuje od cene rotkve u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p> U Srbiji se rotkva sadi i gaji i obrađuje za ishranu stoke i industrijsku proizvodnju i obradu. Rotkva je sorta kupusa. Postoji divlja rotkva, a gaji se domaća rotkva. Rotkva se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p> 
                    `,
                    description_meta : `Cena rotkve na pijaci, otkupna cena rotkve, ponude i potražnje rotkve na svetskoj berzi, trenutna cena rotkve po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('rotkve'),
                    description :  descriptionMarket.srPath('rotkve'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path :  descriptionMarket.srPath('rotkve'),
                    value: "rotkva",
                    value_path: "rotkva",
                    avatar: 'ro',
                    color : FindIcon.find('Rotkva').color,
                    img : FindIcon.find('Rotkva').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    catgeory: 'povrće',
                    title_search : 'rotkve',
                    title_search_re : 'rotkve',
                },
                {
                    id: 87,
                    description_page: `<p>Cena brokolija na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje brokolija na svetskoj berzi, da li je cena na veliko, koja je sorta brokolija. </br></br></p> 

                    <p> Cena varira od pijace do pijace, kraja u Srbiji (cena brokolija u zapadnoj Srbiji se razlikuje od cene brokolija u Vojvodini), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</br></br></p> 
                    
                    <p>  U Srbiji se brokoli sadi i gaji i obrađuje za ishranu i industrijsku proizvodnju. Brokoli se koristi kao prilog jelima, salata, zatim kao sastojak raznih kuvanih i pečenih jela. Brokoli se prodaje i otkupljuje uglavnom po kilogramu težine.</br></br></p> 
                    `,
                    description_meta : `Cena brokolija na pijaci, otkupna cena brokolija, ponude i potražnje brokolija na svetskoj berzi, trenutna cena brokolija po gradovima i krajevima u Srbiji.`,
                    food : false,
                    alt: descriptionAltMarket('brokola'),
                    description :  descriptionMarket.srPath('brokola'),
                    title_path : descriptionMarket.srPath('povrca'),
                    description_path :  descriptionMarket.srPath('brokola'),
                    value: "brokola",
                    value_path: "brokola",
                    avatar: 'br',
                    color : FindIcon.find('Brokola').color,
                    img : FindIcon.find('Brokola').img2,
                    stips_category : 2,
                    ads_category: 'Povrće',
                    stips_source : 1,
                    catgeory: 'povrće',
                    catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacam kliknite na cene po nedeljama',
                    title_search : 'brokola',
                    title_search_re : 'brokola',
                },
                {
                    id: 88,
                    description_page: `<p>Cena hrane za tovne piliće zavisi od ponude i potražnje kukuruza, pšenice, ječma, ostalih žitarica na tržištu. Tovni pilići ili brojleri treba da se hrane kvalitetno, da se uz što manje troškove dobije što više kvalitetnog pilećeg mesa.</br></br></p>

                    <p>Ako se pilići hrane i tove da budu spremni za klanje, onda je to neki okvirni vremenski period od 40 dana, ako se želi postići što veća težina, recimo oko 3.5 kilograma, onda je potrebno piliće toviti oko 56 dana.</br></br></p>
                    
                    <p> Od vrste tova pilića, zavisi i vrsta ishrana, a samim tim i tipa hrane za piliće koja se daje, ako je kraći tov, onda je potrebno oko 3 do 4 smeše hrane za piliće, ako je duži tov onda je potrebno 3 smeše, a da prva smeša bude duža. </br></br></p>
                    
                    <p> Hrana za piliće se vrednuje i ocenjuje na osnovu smeše, koliko ima ugljenih hidrata, koliko masti, koliko proteina, minerala, vitamina.</br></br></p>
                    
                    <p> Kraći tov pilića, koristi se hrana koja postepeno smanjuje proteine. Početna ili starter smeša sadrži oko 22% proteina i daje se prve tri nedelje. Potom se daje smeša koja ima 19% proteina i daje se od 22 dana tova do 35 dana tova. Od 36 dana pa do 40 dana ili dana klanja tovnih pilića koristi se smeša od 17% proteina.</br></br></p>
                    
                    <p> Duži tov pilića, koristi se starter smeša sa 22% proteina do 28 dana tova ili prve četiri nedelje tova, nakon toga daje se smeša sa 19% proteina od 29 do 50 dana tova. Na kraju se daje smeša od 17% proteina od 51 dana tova do 56 dana ili dana klanja.</br></br></p>
                    
                    <p>  U Srbiji se može kupiti smeše hrane za tov pilića od nekoliko kvalitetnih proizvođača hrane za piliće ili od fabrika stočne hrane.</br></br></p>
                     
                    `,
                    description_meta : `Cena hrane za tovne piliće, koncentrat za tovne piliće, starter za tovne piliće, super za tovne piliće , recept hrana za piliće, ishrana pilića, proteini i vitamini za piliće.`,
                    food : true,
                    alt: descriptionFoodAltMarket('piliće'),
                    description :  descriptionFoodMarket('piliće'),
                    title_path : descriptionFoodMarket('pilice'),
                    description_path :  descriptionFoodMarket('pilice'),
                    food_filter : 'Stočna hrana',
                    food_filter_path : 'Stocna hrana',
                    // value: "brokola",
                    // value_path: "brokola",
                    avatar: 'pl',
                    color : FindIcon.find('Petao').color,
                    img : FindIcon.find('Petao').img2,
                    // stips_category : 2,
                    ads_category: 'Povrće',
                    // stips_source : 1,
                    // catgeory: 'povrće',
                    // catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    // title_search : 'brokola',
                    // title_search_re : 'brokola',
                } ,{
                    id: 89,
                    description_page: `<p>Cena hrane za koke nosilje ili kokoške  zavisi od ponude i potražnje kukuruza, pšenice, ječma, ostalih žitarica na tržištu. Kokoške ili koke nosilje treba da se hrane kvalitetno, da se uz što manje troškove dobije što više jaja, odnosno perioda nošenja jaja kokošaka.</br></br></p>

                    <p> Kod kokošaka i krajnjeg cilja kvalitetnih jaja, razlikujemo periode na koje i utiče hrana za kokoške.</br></br></p>
                    
                    <p>  Period rast kokošaka od pileta, 0 do 15 nedelje, može se razlikovati tri glavna podperioda, gde je osnov smeše protein, starter smeša sa 20% proteina daje se od 0 do 5 nedelja, potom grover smeša od 5 do 10 nedelje sa 18% proteina, razvojna smeša od 10 do 16 nedelje sa 15.5% proteina.</br></br></p>
                    
                    <p> Period pred pronošenje, odnosno smeša za pronošenje daje se kokoškama oko dve nedelje pred očekivano prvo jaje pa do dostizanja 5% nosivosti. Specifičnost ove smeše jeste da ima 2.5% kalcijuma i 16% proteina.</br></br></p>
                    
                    <p> Period proizvodnje jaja kod nosilja, može se podeliti u 4 podperioda, zavisno kada se daje smeša od temperature, proteina, kalcijuma, ostalih minerala i vitamina, gde su periodi od 18 do 32 nedelje, od 32 nedelje do 45 nedelje, od 45 do 60 i posle 60 nedelje.</br></br></p>
                    
                    <p>  U Srbiji se može kupiti smeše hrane za kokoše ili koke nosilje od nekoliko kvalitetnih proizvođača hrane za kokoške ili od fabrika stočne hrane.</br></br></p>
                    
                     
                    `,
                    description_meta : `Cena hrane za koke nosilje, koncentrat za kokoške, starter za nosilje, super za nosilje, grover za noslije, recept hrana za kokoške, proteini i vitamini za kokoške. `,
                    food : true,
                    alt: descriptionFoodAltMarket('kokoške'),
                    description :  descriptionFoodMarket('kokoške'),
                    title_path : descriptionFoodMarket('kokoske'),
                    description_path :  descriptionFoodMarket('kokoske'),
                    food_filter : 'Stočna hrana',
                    food_filter_path : 'Stocna hrana',
                    // value: "brokola",
                    // value_path: "brokola",
                    avatar: 'pl',
                    color : FindIcon.find('Petao').color,
                    img : FindIcon.find('Petao').img2,
                    // stips_category : 2,
                    ads_category: 'Povrće',
                    // stips_source : 1,
                    // catgeory: 'povrće',
                    // catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    // title_search : 'brokola',
                    // title_search_re : 'brokola',
                },{
                    id: 90,
                    description_page: `<p>Cena hrane za prasad zavisi od ponude i potražnje kukuruza, pšenice, ječma, ostalih žitarica na tržištu. Prasad treba da se hrani kvalitetno, da se uz što manje troškove dobije što veća kilaža za što manji vremenski period.</br></br></p>

                    <p>Za ishranu prasadi uglavnom se koriste tri smese, hrane za prasadi, u tri podperioda, i to su predstarter za prasad, starter za prasad i grover za prasad. Ovaj kompletan period ishrane prasadi traje oko 60 dana i od njega i njegovog kvaliteta zavisi ukupan odgoj prasadi i kasniji tov svinja.</br></br></p>
                    
                    <p> U Srbiji se može kupiti smeše hrane za prasad od nekoliko kvalitetnih proizvođača hrane za prasad ili od fabrika stočne hrane.</br></br></p>                 
                    `,
                    description_meta : `Cena hrane za prasad, koncentrat za prasad, starter za prasad, grover za prasad, ishrana prasadi,recept hrana za prasad, proteini i vitamini za prasad. `,
                    food : true,
                    alt: descriptionFoodAltMarket('prasad'),
                    description :  descriptionFoodMarket('prasad'),
                    title_path : descriptionFoodMarket('prasad'),
                    description_path :  descriptionFoodMarket('prasad'),
                    food_filter : 'Stočna hrana',
                    food_filter_path : 'Stocna hrana',
                    // value: "brokola",
                    // value_path: "brokola",
                    avatar: 'pl',
                    color : FindIcon.find('Prasad').color,
                    img : FindIcon.find('Prasad').img2,
                    // stips_category : 2,
                    ads_category: 'Povrće',
                    // stips_source : 1,
                    // catgeory: 'povrće',
                    // catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    // title_search : 'brokola',
                    // title_search_re : 'brokola',
                }
                ,{
                    id: 91,
                    description_page: `<p>Cena hrane za svinje ili tov svinja zavisi od ponude i potražnje kukuruza, pšenice, ječma, ostalih žitarica na tržištu. Svinje treba da se hrane kvalitetno, da se uz što manje troškove dobije što veća kilaža za što manji vremenski period.</br></br></p>

                    <p>U tovu svinje bi trebalo dnevno da ostvare optimalan prirast od 700 grama.</br></br></p>
                    
                    <p>Svinje se tove od 25 kg pa do oko 120 kg. Uglavnom koriste se smeše hrane za svinje za period od 25 kg do 60 kg, pa za period od 60 kg do 100 kg, i na kraju od 100 kg pa do klanja, oko 120 kg.</br></br></p>
                    
                    <p>  U Srbiji se može kupiti smeše hrane za svinje od nekoliko kvalitetnih proizvođača hrane za svinje ili od fabrika stočne hrane.</br></br></p>
                                   
                    `,
                    description_meta : `Cena hrane za svinje, koncentrat za svinje, ishrana svinja, dnevni prirast svinja, recept hrana za tov svinja, proteini i vitamini za svinje. `,
                    food : true,
                    alt: descriptionFoodAltMarket('svinje'),
                    description :  descriptionFoodMarket('svinje'),
                    title_path : descriptionFoodMarket('svinje'),
                    description_path :  descriptionFoodMarket('svinje'),
                    food_filter : 'Stočna hrana',
                    food_filter_path : 'Stocna hrana',
                    // value: "brokola",
                    // value_path: "brokola",
                    avatar: 'pl',
                    color : FindIcon.find('Priplodne nazimice').color,
                    img : FindIcon.find('Priplodne nazimice').img2,
                    // stips_category : 2,
                    ads_category: 'Povrće',
                    // stips_source : 1,
                    // catgeory: 'povrće',
                    // catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    // title_search : 'brokola',
                    // title_search_re : 'brokola',
                },{
                    id: 92,
                    description_page: `<p> Cena hrane za tov junadi zavisi od ponude i potražnje deteline, kukuruza, pšenice, ječma, ostalih žitarica na tržištu. Junad za tov treba da se hrani kvalitetno, da se uz što manje troškove dobije što bolja kilaža i napredovnje.</br></br></p>

                    <p> June koje se zaluči i krene u tov, od 6 meseci do 2 godine, bitno je da ima kvalitetnu hranu za junad koja omogućava dnevni prirast od oko 1.500 grama, da june bude zdravo i da za 10 meseci dostigne kilažu do 500 kg.</br></br></p>
                    
                    <p> Hrana za tov junadi, koncentrati, daje se u mlevenom, gnječenom obliku ili granulama i mešaju se sa ostalim sastojcima.</br></br></p>
                    
                    <p>  U Srbiji se može kupiti smeše hrane za tov junadi od nekoliko kvalitetnih proizvođača hrane za tov junadi ili od fabrika stočne hrane.</br></br></p>
                                  
                    `,
                    description_meta : `Cena hrane za tov junadi, koncentrat za junad, recept hrana za tov junadi, ishrana junadi, dnevni prirast tova junadi, proteini i vitamini za junad. `,
                    food : true,
                    alt: descriptionFoodAltMarket('junad'),
                    description :  descriptionFoodMarket('junad'),
                    title_path : descriptionFoodMarket('junad'),
                    description_path :  descriptionFoodMarket('junad'),
                    food_filter : 'Stočna hrana',
                    food_filter_path : 'Stocna hrana',
                    // value: "brokola",
                    // value_path: "brokola",
                    avatar: 'pl',
                    color : FindIcon.find('Junad').color,
                    img : FindIcon.find('Junad').img2,
                    // stips_category : 2,
                    ads_category: 'Povrće',
                    // stips_source : 1,
                    // catgeory: 'povrće',
                    // catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    // title_search : 'brokola',
                    // title_search_re : 'brokola',
                },{
                    id: 93,
                    description_page: ` <p>Cena hrane za tovne ćurke zavisi od ponude i potražnje kukuruza, pšenice, ječma, ostalih žitarica na tržištu. Tovne ćurke treba da se hrane kvalitetno, da se uz što manje troškove dobije što više kvalitetnog ćurećeg mesa.</br></br></p>

                    <p> Ishrana i tov ćuraka traje oko 5 do 6 meseci, sa ciljem da ćurka ima 6 do 9 kg, a ćuran može imati i do 20 kg. </br></br></p>
                    
                    <p>  Jedna ćurka dnevno pojede oko 250 grama hrane, ukupno oko 55 kg hrane za tov.</br></br></p>
                    
                    <p>  Četiri perioda kod tova ćurki postoji, i zavisi po broju nedelja i procenta proteina koji se daju u hrani za tov ćurki za taj period.</br></br></p> 
                    
                    <p>  Prvi period tova ćurki od 1 do 4 nedelje, 28% proteina u smeši, drugi period tova ćurki od 4 do 8 nedelje, 24% proteina u smeši, treći period tova ćurki od 8 do 14 nedelje, 20% proteina u smeši, i četvrti period tova ćurki, od 14 nedelje do kraja tova, 16% proteina u smeši.</br></br></p>
                    
                    <p>   U Srbiji se može kupiti smeše hrane za tov ćurki, od nekoliko kvalitetnih proizvođača hrane za ćurke ili od fabrika stočne hrane.</br></br></p>
                                  
                    `,
                    description_meta : `Cena hrane za tovne ćurke, ishrana i tov ćuraka, koncentrat za ćurke, recept hrana za tov ćurke, proteini i vitamini za ćurke. `,
                    food : true,
                    alt: descriptionFoodAltMarket('ćurke'),
                    description :  descriptionFoodMarket('ćurke'),
                    title_path : descriptionFoodMarket('curke'),
                    description_path :  descriptionFoodMarket('curke'),
                    food_filter : 'Stočna hrana',
                    food_filter_path : 'Stocna hrana',
                    // value: "brokola",
                    // value_path: "brokola",
                    avatar: 'pl',
                    color : FindIcon.find('Ćurka').color,
                    img : FindIcon.find('Ćurka').img2,
                    // stips_category : 2,
                    ads_category: 'Povrće',
                    // stips_source : 1,
                    // catgeory: 'povrće',
                    // catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    // title_search : 'brokola',
                    // title_search_re : 'brokola',
                },{
                    id: 94,
                    description_page: ` <p> Cena hrane za jagnjad zavisi od ponude i potražnje lucerke, kukuruza, pšenice, ječma, ostalih žitarica na tržištu. Jagnjad treba da se hrani kvalitetno, da se uz što manje troškove dobije što bolja kilaža za što kraći period.</br></br></p>

                    <p>Ishrana jagnjadi je uglavnom podeljena na 3 faze, prva kad jagnje sisa mleko do 15 kg i trajanje je oko 25 dana, i to je faza gde jagnje uzima mleko od majke, druga kad jagnje prelazi na čvrstu hranu od 15 do 25 kg i trajanje je oko 30 dana, i tu treba davati hranu za jagnjad koja ima oko 20% proteina, oko 70% svarljivog dela, i odnos kalcijuma i fosfora je 2:1, i treća završna faza ishrane, treba da se daje hrana za jagnjad koja ima oko 14% proteina, i očekivani napredak je oko 400 grama dnevno, nekih 12, 13 dana.</br></br></p>
                    
                    <p> Cilj je da jagnje bude oko 30 kg, za optimalnih 70 dana starosti.</br></br></p>
                    
                    <p>  U Srbiji se može kupiti smeše hrane za jagnjad od nekoliko kvalitetnih proizvođača hrane za jagnjad ili od fabrika stočne hrane.</br></br></p>
                                 
                    `,
                    description_meta : `Cena hrane za jagnjad, koncentrat za jagnjad, recept hrana za jagnjad, starter za jagnjad, proteini i vitamini za jagnjad. `,
                    food : true,
                    alt: descriptionFoodAltMarket('jagnjad'),
                    description :  descriptionFoodMarket('jagnjad'),
                    title_path : descriptionFoodMarket('jagnjad'),
                    description_path :  descriptionFoodMarket('jagnjad'),
                    food_filter : 'Stočna hrana',
                    food_filter_path : 'Stocna hrana',
                    // value: "brokola",
                    // value_path: "brokola",
                    avatar: 'pl',
                    color : FindIcon.find('Jagnjad').color,
                    img : FindIcon.find('Jagnjad').img2,
                    // stips_category : 2,
                    ads_category: 'Povrće',
                    // stips_source : 1,
                    // catgeory: 'povrće',
                    // catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    // title_search : 'brokola',
                    // title_search_re : 'brokola',
                },{
                    id: 95,
                    description_page: ` <p>Cena hrane za krave muzare zavisi od ponude i potražnje deteline, kukuruza, pšenice, ječma, ostalih žitarica na tržištu. Krave treba da se hrane kvalitetno, da se uz što manje troškove dobije što bolja proizvodnja mleka sa jedne strane, a sa druge reprodukcija.</br></br></p>

                    <p> Veća mlečnost krava zavisi od kvaliteta hrane i stoga je jako bitno krave muzare hraniti redovno i kvalitetno.</br></br></p>
                    
                    <p> Cilje je da krava za 305 dana laktacije proizvede 6000 litara mleka, ako to uradi krava, ona izluči oko 200 kg proteina, 260 kg mlečne masti, 8 kg kalcijuma, 6 kg fosfora, i svih ostalih materija u manjim količinama. </br></br></p>
                    
                    <p>  Da se sve ovo nadoknadi i ostvari cilj, hrana za krave, koncentrat, to nadomestuje.</br></br></p>
                    
                    <p>  Osim koncentrata, treba spomenuti i seno lucerke i kukuruznu silažu.</br></br></p>
                    
                    <p>  Dnevna potreba krava je oko 2 kg lucerke na 100 kg težine krave, a 8 kg silaže na 100 kg težine. 1 kg lucerke zamenjuje oko 2.5 kg silaže.</br></br></p>
                    
                    <p>  U Srbiji se može kupiti smeše hrane za krave od nekoliko kvalitetnih proizvođača hrane za krave ili od fabrika stočne hrane.</br></br></p>
                                  
                    `,
                    description_meta : `Cena hrane za krave, koncentrat za krave, ishrana krava, recept hrana za krave, seno lucerke za krave, kukuruzna silaža za krave, proteini i vitamini za krave. `,
                    food : true,
                    alt: descriptionFoodAltMarket('krave'),
                    description :  descriptionFoodMarket('krave'),
                    title_path : descriptionFoodMarket('krave'),
                    description_path :  descriptionFoodMarket('krave'),
                    food_filter : 'Stočna hrana',
                    food_filter_path : 'Stocna hrana',
                    // value: "brokola",
                    // value_path: "brokola",
                    avatar: 'pl',
                    color : FindIcon.find('Krave za klanje').color,
                    img : FindIcon.find('Krave za klanje').img2,
                    // stips_category : 2,
                    ads_category: 'Povrće',
                    // stips_source : 1,
                    // catgeory: 'povrće',
                    // catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    // title_search : 'brokola',
                    // title_search_re : 'brokola',
                },{
                    id: 96,
                    description_page: `<p> Cena hrane za krmače, krmače u laktaciji i priplodne nazimice zavisi od ponude i potražnje kukuruza, pšenice, ječma, ostalih žitarica na tržištu. Krmače treba da se hrane kvalitetno, da se uz što manje troškove dobije što bolja reprodukcija i prašenje krmača.</br></br></p>

                    <p>  Ishrana priplodnih nazimica, kada se prasad ili mlada svinja zaluči i odredi da će biti krmača, njena ishrana treba da obiluje proteinima, i treba da se obezbedi metabolička energija za reprodukciju.</br></br></p>
                    
                    <p>  Ishrana suprasnih krmača, ne treba da bude ništa specifična, čak i manja nego kad su nazimice, treba da im se daje osnovna hrana, nikako jaka jer je nepotrebna zbog troškova, ali i što je važnije može uticati na reprodukciju.</br></br></p>
                    
                    <p>  Ishrana krmača u laktaciji, treba voditi računa i o prasićima, budućoj suprasnosti, i krmače treba hraniti samo najkvalitetnjom smešom.</br></br></p>
                    
                    <p>  U Srbiji se može kupiti smeše hrane za krmače od nekoliko kvalitetnih proizvođača hrane za krmače ili od fabrika stočne hrane.</br></br></p>
                                  
                    `,
                    description_meta : `Cena hrane za krmače, koncentrat za krmače, ishrana krmača, hrana za nazimice, recept hrana za krmače, proteini i vitamini za krmače. `,
                    food : true,
                    alt: descriptionFoodAltMarket('krmače'),
                    description :  descriptionFoodMarket('krmače'),
                    title_path : descriptionFoodMarket('krmace'),
                    description_path :  descriptionFoodMarket('krmace'),
                    food_filter : 'Stočna hrana',
                    food_filter_path : 'Stocna hrana',
                    // value: "brokola",
                    // value_path: "brokola",
                    avatar: 'pl',
                    color : FindIcon.find('Krmače za klanje').color,
                    img : FindIcon.find('Krmače za klanje').img2,
                    // stips_category : 2,
                    ads_category: 'Povrće',
                    // stips_source : 1,
                    // catgeory: 'povrće',
                    // catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    // title_search : 'brokola',
                    // title_search_re : 'brokola',
                },{
                    id: 97,
                    description_page: `<p>  Cena hrane za neraste zavisi od ponude i potražnje kukuruza, pšenice, ječma, ostalih žitarica na tržištu. Nerast treba da se hrani kvalitetno, da se uz što manje troškove dobije što bolja reprodukcija sa krmačama.</br></br></p>

                    <p> Kada se zaluči prase, i postane potencijalni nerast, u periodu ishrane od 25 do 100 kg, treba da se hrani samo kvalitetnom smešom koja obezbeđuje visok dnevni prirast, ali i razvoj konstitucije praseta do kada postane nerast. </br></br></p>
                    
                    <p>   Voditi računa da prase ne padne na noge ili otežano kreće.</br></br></p>
                    
                    <p>  U Srbiji se može kupiti smeše hrane za neraste od nekoliko kvalitetnih proizvođača hrane za neraste ili od fabrika stočne hrane.</br></br></p>
                                 
                    `,
                    description_meta : `Cena hrane za neraste, koncentrat za neraste, ishrana nerasta, recept hrana za neraste, proteini i vitamini za neraste. `,
                    food : true,
                    alt: descriptionFoodAltMarket('neraste'),
                    description :  descriptionFoodMarket('neraste'),
                    title_path : descriptionFoodMarket('neraste'),
                    description_path :  descriptionFoodMarket('neraste'),
                    food_filter : 'Stočna hrana',
                    food_filter_path : 'Stocna hrana',
                    // value: "brokola",
                    // value_path: "brokola",
                    avatar: 'pl',
                    color : FindIcon.find('Priplodne nazimice').color,
                    img : FindIcon.find('Priplodne nazimice').img2,
                    // stips_category : 2,
                    ads_category: 'Povrće',
                    // stips_source : 1,
                    // catgeory: 'povrće',
                    // catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    // title_search : 'brokola',
                    // title_search_re : 'brokola',
                },{
                    id: 98,
                    description_page: `<p>  Cena hrane za telad zavisi od ponude i potražnje kukuruza, pšenice, ječma, ostalih žitarica na tržištu. Telad treba da se hrani kvalitetno, da se uz što manje troškove dobije što bolja kilaža i napredovnje.</br></br></p>

                    <p> Ishrana teladi počinje od njegovog dolaska na svet, gde je za tele najvažnije da prvih 7 dana sisa, nakon toga u narednih nekoliko dana, do 10 dana tele može preći i na zamensku hranu, a posle uzima drugu hranu, najpre najkvalitetniju detelinu lucerku i starter za zalučenu telad. Tri nedelje povećava se ishrana, i suva hrana. </br></br></p>
                    
                    <p>  Jako je važno naglasiti, da se vodi računa o svim tim prelascima u ishrani i davanju količine hrane za telad, da to bude jako postepeno i oprezno, da ne bi došlo do težih poremećaja u varenju.</br></br></p>
                    
                    <p>  Optimalna količina hrane za telad je oko 2 do 2.5 kg dnevno, a cilj je da tele napreduje za 6 meseci do 250 kg.</br></br></p>
                    
                    <p>  Hrana za tov teladi, koncentrati, daje se u mlevenom, gnječenom obliku ili granulama i mešaju se sa ostalim sastojcima, detelinom.</br></br></p>
                    
                    <p>   U Srbiji se može kupiti smeše hrane za tov teladi od nekoliko kvalitetnih proizvođača hrane za telad ili od fabrika stočne hrane.</br></br></p>
                                 
                    `,
                    description_meta : `Cena hrane za tov teladi, koncentrat za telad, ishrana teladi, recept hrana za tov teladi, dnevni prirast tova teladi, proteini i vitamini za telad. `,
                    food : true,
                    alt: descriptionFoodAltMarket('telad'),
                    description :  descriptionFoodMarket('telad'),
                    title_path : descriptionFoodMarket('telad'),
                    description_path :  descriptionFoodMarket('telad'),
                    food_filter : 'Stočna hrana',
                    food_filter_path : 'Stocna hrana',
                    // value: "brokola",
                    // value_path: "brokola",
                    avatar: 'pl',
                    color : FindIcon.find('Teladi').color,
                    img : FindIcon.find('Teladi').img2,
                    // stips_category : 2,
                    ads_category: 'Povrće',
                    // stips_source : 1,
                    // catgeory: 'povrće',
                    // catgeory_path: 'povrce',
                    text_other: 'Ako želite da pogledate cene na kvantaškim pijacama kliknite na cene po nedeljama',
                    // title_search : 'brokola',
                    // title_search_re : 'brokola',
                }
    ]

    
}
